var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 15.834C43.5739 15.8499 43.924 15.8817 44.2263 15.8976C44.5127 15.9135 44.7514 15.9135 44.9265 15.9135C45.1333 15.9135 45.563 15.8976 46.1995 15.8658C46.4382 15.8499 46.6291 15.8499 46.7405 15.8499V16.3591C46.3904 16.375 46.1518 16.4228 46.0404 16.4705C45.929 16.5182 45.8812 16.6296 45.8812 16.7888C45.8812 16.8524 45.8972 16.9479 45.9131 17.0434C45.929 17.1388 45.9767 17.2502 46.0245 17.3775L48.0295 23.0584L49.9231 17.3934C49.9867 17.2502 50.0186 17.1388 50.0345 17.0751C50.0504 17.0115 50.0504 16.916 50.0504 16.8365C50.0504 16.6614 49.9867 16.5341 49.8435 16.4546C49.7003 16.375 49.4616 16.3431 49.1274 16.3431V15.834C49.4457 15.8499 49.6844 15.8658 49.8913 15.8817C50.0981 15.8976 50.2573 15.8976 50.4005 15.8976C50.5119 15.8976 50.6551 15.8976 50.8301 15.8817C51.0052 15.8658 51.2598 15.8658 51.578 15.834V16.3431C51.2757 16.3591 51.0688 16.4227 50.9574 16.5023C50.846 16.5818 50.7506 16.7091 50.7028 16.9001L48.6501 22.8037C48.5228 23.1538 48.3955 23.5198 48.2522 23.9017C48.109 24.2836 47.9658 24.6815 47.8067 25.0793L47.1702 25.0156L44.2104 17.1706L44.1945 17.1229C44.0035 16.5978 43.6694 16.3431 43.192 16.3431L43.1602 15.834Z",
    fill: "url(#paint0_radial_578_447482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 15.834C43.5739 15.8499 43.924 15.8817 44.2263 15.8976C44.5127 15.9135 44.7514 15.9135 44.9265 15.9135C45.1333 15.9135 45.563 15.8976 46.1995 15.8658C46.4382 15.8499 46.6291 15.8499 46.7405 15.8499V16.3591C46.3904 16.375 46.1518 16.4228 46.0404 16.4705C45.929 16.5182 45.8812 16.6296 45.8812 16.7888C45.8812 16.8524 45.8972 16.9479 45.9131 17.0434C45.929 17.1388 45.9767 17.2502 46.0245 17.3775L48.0295 23.0584L49.9231 17.3934C49.9867 17.2502 50.0186 17.1388 50.0345 17.0751C50.0504 17.0115 50.0504 16.916 50.0504 16.8365C50.0504 16.6614 49.9867 16.5341 49.8435 16.4546C49.7003 16.375 49.4616 16.3431 49.1274 16.3431V15.834C49.4457 15.8499 49.6844 15.8658 49.8913 15.8817C50.0981 15.8976 50.2573 15.8976 50.4005 15.8976C50.5119 15.8976 50.6551 15.8976 50.8301 15.8817C51.0052 15.8658 51.2598 15.8658 51.578 15.834V16.3431C51.2757 16.3591 51.0688 16.4227 50.9574 16.5023C50.846 16.5818 50.7506 16.7091 50.7028 16.9001L48.6501 22.8037C48.5228 23.1538 48.3955 23.5198 48.2522 23.9017C48.109 24.2836 47.9658 24.6815 47.8067 25.0793L47.1702 25.0156L44.2104 17.1706L44.1945 17.1229C44.0035 16.5978 43.6694 16.3431 43.192 16.3431L43.1602 15.834Z",
    fill: "url(#paint1_radial_578_447482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9434 15.834C43.3571 15.8499 43.7072 15.8817 44.0095 15.8976C44.2959 15.9135 44.5346 15.9135 44.7097 15.9135C44.9165 15.9135 45.3462 15.8976 45.9827 15.8658C46.2214 15.8499 46.4123 15.8499 46.5237 15.8499V16.3591C46.1737 16.375 45.935 16.4228 45.8236 16.4705C45.7122 16.5182 45.6644 16.6296 45.6644 16.7888C45.6644 16.8524 45.6804 16.9479 45.6963 17.0434C45.7122 17.1388 45.7599 17.2502 45.8077 17.3775L47.8127 23.0584L49.7063 17.3934C49.7699 17.2502 49.8018 17.1388 49.8177 17.0751C49.8336 17.0115 49.8336 16.916 49.8336 16.8365C49.8336 16.6614 49.7699 16.5341 49.6267 16.4546C49.4835 16.375 49.2448 16.3431 48.9106 16.3431V15.834C49.2289 15.8499 49.4676 15.8658 49.6745 15.8817C49.8813 15.8976 50.0405 15.8976 50.1837 15.8976C50.2951 15.8976 50.4383 15.8976 50.6133 15.8817C50.7884 15.8658 51.043 15.8658 51.3612 15.834V16.3431C51.0589 16.3591 50.852 16.4227 50.7406 16.5023C50.6292 16.5818 50.5338 16.7091 50.486 16.9001L48.4333 22.8037C48.306 23.1538 48.1787 23.5198 48.0354 23.9017C47.8922 24.2836 47.749 24.6815 47.5899 25.0793L46.9534 25.0156L43.9936 17.1706L43.9777 17.1229C43.7867 16.5978 43.4526 16.3431 42.9752 16.3431L42.9434 15.834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1436 15.834C43.5573 15.8499 43.9074 15.8817 44.2097 15.8976C44.4961 15.9135 44.7348 15.9135 44.9099 15.9135C45.1167 15.9135 45.5464 15.8976 46.1829 15.8658C46.4216 15.8499 46.6125 15.8499 46.7239 15.8499V16.3591C46.3738 16.375 46.1352 16.4228 46.0238 16.4705C45.9124 16.5182 45.8646 16.6296 45.8646 16.7888C45.8646 16.8524 45.8805 16.9479 45.8965 17.0434C45.9124 17.1388 45.9601 17.2502 46.0079 17.3775L48.0129 23.0584L49.9065 17.3934C49.9701 17.2502 50.002 17.1388 50.0179 17.0751C50.0338 17.0115 50.0338 16.916 50.0338 16.8365C50.0338 16.6614 49.9701 16.5341 49.8269 16.4546C49.6837 16.375 49.445 16.3431 49.1108 16.3431V15.834C49.4291 15.8499 49.6678 15.8658 49.8747 15.8817C50.0815 15.8976 50.2407 15.8976 50.3839 15.8976C50.4953 15.8976 50.6385 15.8976 50.8135 15.8817C50.9886 15.8658 51.2432 15.8658 51.5614 15.834V16.3431C51.2591 16.3591 51.0522 16.4227 50.9408 16.5023C50.8294 16.5818 50.734 16.7091 50.6862 16.9001L48.6335 22.8037C48.5062 23.1538 48.3789 23.5198 48.2356 23.9017C48.0924 24.2836 47.9492 24.6815 47.7901 25.0793L47.1536 25.0156L44.1938 17.1706L44.1779 17.1229C43.9869 16.5978 43.6528 16.3431 43.1754 16.3431L43.1436 15.834Z",
    fill: "url(#paint2_radial_578_447482)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8858 22.6766L46.0081 17.3618C45.9603 17.2345 45.9285 17.1072 45.8967 17.0276C45.8648 16.948 45.8648 16.8526 45.8648 16.773C45.8648 16.6775 45.8808 16.598 45.9285 16.5343C45.833 16.5502 45.7694 16.5661 45.7216 16.5979C45.6102 16.6616 45.5625 16.7571 45.5625 16.9162C45.5625 16.9798 45.5784 17.0753 45.5943 17.1708C45.6102 17.2663 45.658 17.3777 45.7057 17.505L47.7107 23.1858L47.8858 22.6766Z",
    fill: "url(#paint3_radial_578_447482)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9074 16.0408C44.1938 16.0567 44.4325 16.0567 44.6075 16.0567C44.8144 16.0567 45.244 16.0409 45.8805 16.009C46.1192 15.9931 46.3102 15.9931 46.4216 15.9931V16.375C46.5171 16.3591 46.6125 16.3591 46.7239 16.3591V15.8499C46.5966 15.8499 46.4216 15.8658 46.1829 15.8658C45.5464 15.8976 45.1167 15.9135 44.9099 15.9135C44.7507 15.9135 44.512 15.8976 44.2097 15.8976C43.9233 15.8817 43.5573 15.8658 43.1436 15.834V16.009C43.4459 16.025 43.7005 16.0249 43.9074 16.0408Z",
    fill: "url(#paint4_radial_578_447482)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.813 15.8818C50.638 15.8977 50.4948 15.8977 50.3834 15.8977C50.2402 15.8977 50.081 15.8977 49.8742 15.8818C49.6673 15.8659 49.4286 15.8659 49.1104 15.8341V16.0092C49.2854 16.0251 49.4445 16.025 49.5718 16.025C49.7787 16.0409 49.9378 16.0409 50.081 16.0409C50.1924 16.0409 50.3356 16.0409 50.5107 16.025C50.6857 16.0091 50.9403 16.0091 51.2586 15.9773V16.3592C51.3541 16.3433 51.4495 16.3274 51.5609 16.3115V15.8022C51.2427 15.85 50.9881 15.8659 50.813 15.8818Z",
    fill: "url(#paint5_radial_578_447482)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6222 16.6452C50.5108 16.7088 50.4154 16.852 50.3676 17.043L48.3149 22.9466C48.1876 23.2967 48.0603 23.6627 47.9171 24.0446C47.8057 24.3629 47.6625 24.697 47.5352 25.0471L47.7738 25.063C47.933 24.6652 48.0762 24.2674 48.2194 23.8855C48.3626 23.5036 48.4899 23.1375 48.6172 22.7874L50.67 16.8839C50.7177 16.7407 50.7814 16.6292 50.8609 16.5497C50.7655 16.5656 50.6859 16.5974 50.6222 16.6452Z",
    fill: "url(#paint6_radial_578_447482)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6528 39.2126V40.1601C62.6528 41.9236 61.7836 43.5423 60.3785 44.3846L49.507 50.9253C47.6852 52.0307 45.4823 52.0307 43.6604 50.9253L32.789 44.3846C31.3839 43.5423 30.5146 41.9236 30.5146 40.1601V39.2126C30.5146 40.9761 31.3839 42.5948 32.789 43.437L43.6604 49.9777C45.4823 51.0832 47.6852 51.0832 49.507 49.9777L60.3785 43.437C61.7836 42.5816 62.6528 40.9761 62.6528 39.2126Z",
    fill: "url(#paint7_linear_578_447482)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6528 34.4103V39.4078C62.6528 41.211 61.7836 42.8662 60.3785 43.7274L49.507 50.4155C47.6852 51.5459 45.4823 51.5459 43.6604 50.4155L32.789 43.7274C31.3839 42.8662 30.5146 41.211 30.5146 39.4078V34.4103L44.1606 33.9443L46.5778 32.4507L48.995 33.9443L62.6528 34.4103Z",
    fill: "url(#paint8_linear_578_447482)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1715 34.1968L49.2175 41.3678C47.4206 42.3718 45.2479 42.3718 43.451 41.3678L30.4971 34.1968L46.3519 25.4242L62.1715 34.1968Z",
    fill: "url(#paint9_radial_578_447482)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6448 41.1134C47.816 42.1174 45.6047 42.1174 43.776 41.1134L30.9028 34.121L30.5801 34.3003L43.7641 41.472C45.5928 42.476 47.816 42.476 49.6328 41.472L62.8168 34.3003L62.4941 34.121L49.6448 41.1134Z",
    fill: "url(#paint10_radial_578_447482)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5949 34.2882V39.1649L62.2245 34.6946L56.248 37.7425L61.8778 34.336L56.3556 30.9414L62.5949 34.2882Z",
    fill: "url(#paint11_radial_578_447482)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5088 34.3243V39.2011L30.8674 34.7307L36.8557 37.7787L31.2141 34.3721L36.7362 30.9775L30.5088 34.3243Z",
    fill: "url(#paint12_radial_578_447482)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2053 28.6505C66.1094 28.6505 45.7033 28.149 26.8828 28.6505C26.8828 28.6505 47.2963 29.0119 66.1168 28.6505",
    fill: "url(#paint13_radial_578_447482)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4291 24.3822V25.5177L72.9987 27.729C71.899 28.4342 70.62 28.8167 69.3172 28.8167H67.1418L65.1337 30.8248C65.1218 30.8367 65.0978 30.8607 65.0739 30.8726C64.8588 31.0758 64.5839 31.2311 64.2851 31.3029C64.2612 31.3148 64.2373 31.3148 64.2014 31.3148C64.1655 31.3268 64.1297 31.3268 64.0819 31.3388C63.9743 31.3507 63.8667 31.3626 63.7591 31.3626H58.4043V24.8125L67.1179 24.5974L76.4291 24.3822Z",
    fill: "url(#paint14_radial_578_447482)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1533 24.6215L76.4406 24.3944V25.5299L73.0102 27.7412C71.9105 28.4464 70.6316 28.8289 69.3287 28.8289H67.1533V24.6215Z",
    fill: "url(#paint15_radial_578_447482)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.286 24.3822L72.987 26.5098C71.8874 27.2151 70.6084 27.5975 69.3056 27.5975H67.1301L65.1221 29.6056C64.7635 29.9642 64.2734 30.1674 63.7714 30.1674H58.4404V30.251H63.7953C64.2973 30.251 64.7993 30.0478 65.146 29.6892L67.1541 27.6812H69.3294C70.6323 27.6812 71.9232 27.2987 73.0109 26.5935L76.4414 24.3822H76.286Z",
    fill: "url(#paint16_radial_578_447482)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0858 29.3545V30.8725C64.8707 31.0757 64.5957 31.2311 64.2969 31.3028C64.273 31.3147 64.2491 31.3147 64.2133 31.3147C64.1774 31.3267 64.1416 31.3267 64.0938 31.3387V29.3306L65.0858 29.3545Z",
    fill: "url(#paint17_radial_578_447482)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4286 24.3822L72.9982 26.5935C71.8985 27.2987 70.6196 27.6812 69.3167 27.6812H67.1413L65.1332 29.6892C64.7746 30.0478 64.2846 30.251 63.7826 30.251H58.4277V24.8484L76.082 24.4061L76.4286 24.3822Z",
    fill: "url(#paint18_radial_578_447482)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4404 24.8364L76.1306 24.4898L72.999 26.5098C71.8993 27.2151 70.6203 27.5975 69.3175 27.5975H67.1421L65.134 29.6056C64.7754 29.9642 64.2854 30.1674 63.7834 30.1674H58.4524V30.251H63.8073C64.3093 30.251 64.8113 30.0478 65.1579 29.6892L67.166 27.6812H69.3414C70.6443 27.6812 71.9351 27.2987 73.0229 26.5935L74.6604 25.5297L76.3458 24.5495L76.4414 25.5177V24.3822L58.4404 24.8364Z",
    fill: "url(#paint19_radial_578_447482)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7195 30.1437C56.7195 30.1563 56.7195 30.1563 56.7195 30.1437C56.7069 30.1563 56.7195 30.1437 56.7195 30.1437Z",
    fill: "url(#paint20_radial_578_447482)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2891 25.3148L72.8189 26.2351C71.9463 26.7849 70.9423 27.0838 69.9143 27.1077L58.4277 27.3586V25.5179C62.3483 25.4462 74.3369 25.2669 74.2891 25.3148Z",
    fill: "url(#paint21_radial_578_447482)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.795 27.3586L65.2172 28.9962H58.4639V27.5141L66.795 27.3586Z",
    fill: "url(#paint22_radial_578_447482)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4174 24.4307V25.5662L72.987 27.7775C71.8873 28.4827 70.6084 28.8652 69.3055 28.8652H67.1301L65.122 30.8733C65.1101 30.8852 65.0862 30.9091 65.0623 30.9211C64.8471 31.1243 64.5722 31.2797 64.2734 31.3514C64.2495 31.3633 64.2255 31.3633 64.1897 31.3633C64.1538 31.3752 64.118 31.3753 64.0702 31.3872C63.9626 31.3992 63.855 31.4112 63.7475 31.4112H58.3926V24.861L67.1062 24.6458L76.4174 24.4307Z",
    fill: "url(#paint23_radial_578_447482)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4404 24.8006L76.1306 24.454L72.999 26.474C71.8993 27.1792 70.6203 27.5617 69.3175 27.5617H67.1421L65.134 29.5698C64.7754 29.9284 64.2854 30.1316 63.7834 30.1316H58.4524V30.2153H63.8073C64.3093 30.2153 64.8113 30.0121 65.1579 29.6535L67.166 27.6454H69.3414C70.6443 27.6454 71.9351 27.2629 73.0229 26.5577L74.6604 25.4939L76.3458 24.5138L76.4414 25.482V24.3464L58.4404 24.8006Z",
    fill: "url(#paint24_radial_578_447482)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1303 25.6817L72.9987 27.7017C71.8991 28.4069 70.6201 28.7894 69.3172 28.7894H67.1419L65.1338 30.7975C64.7752 31.1561 64.2851 31.3593 63.7831 31.3593H58.4521V31.443H63.807C64.3091 31.443 64.8111 31.2398 65.1577 30.8812L67.1657 28.8731H69.3412C70.644 28.8731 71.9349 28.4906 73.0226 27.7854L74.6602 26.7216L76.4126 25.7219V25.4763L76.1303 25.6817Z",
    fill: "#454545"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2148 24.382V25.5175L20.6453 27.7287C21.745 28.434 23.0239 28.8165 24.3268 28.8165H26.5022L28.5102 30.8245C28.5222 30.8365 28.5461 30.8604 28.57 30.8724C28.7852 31.0756 29.0601 31.2309 29.3589 31.3026C29.3828 31.3146 29.4067 31.3146 29.4426 31.3146C29.4785 31.3265 29.5143 31.3266 29.5621 31.3385C29.6697 31.3505 29.7772 31.3624 29.8848 31.3624H35.2397V24.8123L26.5261 24.5971L17.2148 24.382Z",
    fill: "url(#paint25_radial_578_447482)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5022 24.6215L17.2148 24.3944V25.5299L20.6453 27.7412C21.745 28.4464 23.0239 28.8289 24.3268 28.8289H26.5022V24.6215Z",
    fill: "url(#paint26_radial_578_447482)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3819 24.382L20.6809 26.5096C21.7806 27.2148 23.0596 27.5973 24.3624 27.5973H26.5378L28.5459 29.6054C28.9045 29.9639 29.3945 30.1671 29.8965 30.1671H35.2275V30.2508H29.8726C29.3706 30.2508 28.8686 30.0476 28.522 29.689L26.5139 27.6809H24.3385C23.0356 27.6809 21.7447 27.2984 20.657 26.5932L17.2266 24.382H17.3819Z",
    fill: "url(#paint27_radial_578_447482)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 29.3544V30.8724C28.7855 31.0756 29.0604 31.2309 29.3592 31.3027C29.3831 31.3146 29.407 31.3146 29.4429 31.3146C29.4788 31.3266 29.5146 31.3266 29.5624 31.3386V29.3304L28.5703 29.3544Z",
    fill: "url(#paint28_radial_578_447482)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2148 24.382L20.6453 26.5932C21.745 27.2984 23.0239 27.6809 24.3268 27.6809H26.5022L28.5102 29.689C28.8688 30.0476 29.3589 30.2508 29.8609 30.2508H35.2158V24.8481L17.5615 24.4059L17.2148 24.382Z",
    fill: "url(#paint29_radial_578_447482)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2275 24.8362L17.5373 24.4895L20.6689 26.5096C21.7686 27.2148 23.0476 27.5973 24.3504 27.5973H26.5258L28.5339 29.6054C28.8925 29.9639 29.3826 30.1671 29.8846 30.1671H35.2155V30.2508H29.8607C29.3587 30.2508 28.8566 30.0476 28.51 29.689L26.502 27.6809H24.3265C23.0237 27.6809 21.7328 27.2984 20.6451 26.5932L19.0075 25.5294L17.3222 24.5493L17.2266 25.5175V24.382L35.2275 24.8362Z",
    fill: "url(#paint30_radial_578_447482)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9365 30.1436C36.9491 30.1562 36.9491 30.1562 36.9365 30.1436C36.9491 30.1436 36.9491 30.1562 36.9365 30.1436Z",
    fill: "url(#paint31_radial_578_447482)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3664 25.3145L20.8366 26.2348C21.7091 26.7847 22.7132 27.0835 23.7411 27.1074L35.2278 27.3584V25.5177C31.3072 25.446 19.3185 25.2667 19.3664 25.3145Z",
    fill: "url(#paint32_radial_578_447482)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8604 27.3585L28.4381 28.9961H35.1914V27.5139L26.8604 27.3585Z",
    fill: "url(#paint33_radial_578_447482)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2393 24.4304V25.5659L20.6697 27.7772C21.7693 28.4824 23.0483 28.8649 24.3512 28.8649H26.5266L28.5347 30.873C28.5466 30.885 28.5705 30.9089 28.5944 30.9208C28.8096 31.124 29.0845 31.2794 29.3833 31.3511C29.4072 31.3631 29.4311 31.363 29.467 31.363C29.5028 31.375 29.5387 31.375 29.5865 31.387C29.6941 31.3989 29.8017 31.4109 29.9092 31.4109H35.2641V24.8607L26.5505 24.6456L17.2393 24.4304Z",
    fill: "url(#paint34_radial_578_447482)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2275 24.8004L17.5373 24.4538L20.6689 26.4738C21.7686 27.179 23.0476 27.5615 24.3504 27.5615H26.5258L28.5339 29.5695C28.8925 29.9281 29.3826 30.1313 29.8846 30.1313H35.2155V30.215H29.8607C29.3587 30.215 28.8566 30.0118 28.51 29.6532L26.502 27.6452H24.3265C23.0237 27.6452 21.7328 27.2627 20.6451 26.5575L19.0075 25.4937L17.3222 24.5135L17.2266 25.4817V24.3462L35.2275 24.8004Z",
    fill: "url(#paint35_radial_578_447482)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0368 10.2158L51.5062 9.21071L47.4401 8.85813C46.1383 8.74833 44.8288 9.00804 43.6769 9.61748L41.7536 10.6351L39.04 9.79704C39.0238 9.79205 38.9915 9.78203 38.9648 9.78263C38.6796 9.70342 38.364 9.6945 38.0663 9.77081C38.0396 9.77141 38.0184 9.78259 37.9867 9.79937C37.9494 9.80556 37.9177 9.82231 37.8698 9.8341C37.7691 9.87384 37.6684 9.91362 37.5733 9.96394L32.839 12.4688L35.8995 18.2663L43.7039 14.3808L52.0368 10.2158Z",
    fill: "url(#paint36_linear_578_447482)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.724 14.3426L52.0412 10.1993L51.5106 9.19421L47.4445 8.84164C46.1428 8.73183 44.8333 8.99154 43.6814 9.60098L41.7581 10.6186L43.724 14.3426Z",
    fill: "url(#paint37_radial_578_447482)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9096 10.2828L47.9987 9.94273C46.697 9.83292 45.3875 10.0927 44.2357 10.7021L42.3123 11.7197L39.5986 10.8816C39.1141 10.732 38.5858 10.7814 38.142 11.0162L33.4287 13.5099L33.3896 13.4358L38.124 10.9309C38.5679 10.6961 39.1067 10.6412 39.5807 10.7964L42.2943 11.6344L44.2176 10.6169C45.3695 10.0074 46.6896 9.74211 47.9808 9.85751L52.0469 10.2101L51.9096 10.2828Z",
    fill: "url(#paint38_radial_578_447482)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6843 11.1206L38.975 9.77698C38.6898 9.69776 38.3742 9.68887 38.0765 9.76517C38.0497 9.76578 38.0286 9.77693 37.9969 9.79371C37.9596 9.7999 37.9279 9.81665 37.8801 9.82844L38.8184 11.6058L39.6843 11.1206Z",
    fill: "url(#paint39_radial_578_447482)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0361 10.2158L47.97 9.86328C46.6683 9.75347 45.3587 10.0132 44.2069 10.6226L42.2836 11.6402L39.5699 10.8022C39.0853 10.6525 38.5571 10.7019 38.1132 10.9367L33.3789 13.4415L35.9033 18.2235L51.7185 10.3568L52.0361 10.2158Z",
    fill: "url(#paint40_radial_578_447482)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9196 18.2283L51.7219 10.2603L48.0093 9.93714C46.7075 9.82733 45.3981 10.0871 44.2462 10.6965L42.3229 11.7141L39.6092 10.876C39.1246 10.7264 38.5964 10.7758 38.1526 11.0106L33.4393 13.5043L33.4002 13.4302L38.1346 10.9253C38.5785 10.6905 39.1172 10.6356 39.5912 10.7908L42.3049 11.6289L44.2282 10.6113C45.3801 10.0018 46.7001 9.73655 47.9913 9.85194L49.9362 10.0275L51.8842 10.1067L51.5164 9.20503L52.0469 10.2101L35.9196 18.2283Z",
    fill: "url(#paint41_radial_578_447482)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.918 14.3358C31.9122 14.3246 31.9122 14.3246 31.918 14.3358C31.901 14.3305 31.918 14.3358 31.918 14.3358Z",
    fill: "url(#paint42_radial_578_447482)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7091 10.3912L47.9793 10.2643C46.9509 10.1858 45.9236 10.391 45.0036 10.8507L34.7307 16.0016L35.5908 17.6309C39.0905 15.8604 49.7737 10.4112 49.7091 10.3912Z",
    fill: "url(#paint43_radial_578_447482)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1285 12.0876L39.9683 11.3762L33.9975 14.5352L34.6901 15.8471L42.1285 12.0876Z",
    fill: "url(#paint44_radial_578_447482)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0036 10.1785L51.4731 9.17345L47.4069 8.8209C46.1051 8.7111 44.7957 8.97078 43.6438 9.58022L41.7204 10.5978L39.0068 9.75973C38.9906 9.75474 38.9583 9.74477 38.9316 9.74537C38.6464 9.66616 38.3308 9.65722 38.0331 9.73352C38.0063 9.73413 37.9852 9.74536 37.9535 9.76213C37.9162 9.76833 37.8845 9.78508 37.8366 9.79686C37.7359 9.83661 37.6353 9.87631 37.5402 9.92663L32.8058 12.4315L35.8663 18.2291L43.6707 14.3436L52.0036 10.1785Z",
    fill: "url(#paint45_linear_578_447482)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9362 18.26L51.7385 10.2919L48.0259 9.9688C46.7242 9.859 45.4147 10.1187 44.2628 10.7281L42.3395 11.7457L39.6258 10.9077C39.1412 10.7581 38.613 10.8074 38.1692 11.0422L33.4559 13.5359L33.4168 13.4618L38.1512 10.957C38.5951 10.7221 39.1338 10.6672 39.6078 10.8224L42.3215 11.6605L44.2448 10.6429C45.3967 10.0334 46.7167 9.76816 48.0079 9.88356L49.9528 10.0591L51.9008 10.1383L51.533 9.23664L52.0635 10.2417L35.9362 18.26Z",
    fill: "url(#paint46_radial_578_447482)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M41.138 10.2158L41.6686 9.21071L45.7347 8.85813C47.0365 8.74833 48.346 9.00804 49.4979 9.61748L51.4212 10.6351L54.1349 9.79704C54.151 9.79205 54.1833 9.78203 54.2101 9.78263C54.4952 9.70342 54.8108 9.6945 55.1085 9.77081C55.1352 9.77141 55.1564 9.78259 55.1881 9.79937C55.2254 9.80556 55.2571 9.82231 55.305 9.8341C55.4057 9.87384 55.5064 9.91362 55.6015 9.96394L60.3358 12.4688L57.2753 18.2663L49.4709 14.3808L41.138 10.2158Z",
    fill: "url(#paint47_linear_578_447482)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4508 14.3426L41.1336 10.1993L41.6642 9.19421L45.7303 8.84164C47.032 8.73183 48.3415 8.99154 49.4934 9.60098L51.4167 10.6186L49.4508 14.3426Z",
    fill: "url(#paint48_radial_578_447482)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2652 10.2828L45.1761 9.94273C46.4778 9.83292 47.7873 10.0927 48.9392 10.7021L50.8625 11.7197L53.5762 10.8816C54.0607 10.732 54.589 10.7814 55.0328 11.0162L59.7461 13.5099L59.7852 13.4358L55.0508 10.9309C54.6069 10.6961 54.0682 10.6412 53.5941 10.7964L50.8805 11.6344L48.9572 10.6169C47.8053 10.0074 46.4852 9.74211 45.194 9.85751L41.1279 10.2101L41.2652 10.2828Z",
    fill: "url(#paint49_radial_578_447482)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4905 11.1206L54.1998 9.77698C54.485 9.69776 54.8006 9.68887 55.0983 9.76517C55.1251 9.76578 55.1462 9.77693 55.1779 9.79371C55.2152 9.7999 55.2469 9.81665 55.2947 9.82844L54.3564 11.6058L53.4905 11.1206Z",
    fill: "url(#paint50_radial_578_447482)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1387 10.2158L45.2048 9.86328C46.5066 9.75347 47.8161 10.0132 48.9679 10.6226L50.8913 11.6402L53.6049 10.8022C54.0895 10.6525 54.6177 10.7019 55.0616 10.9367L59.7959 13.4415L57.2715 18.2235L41.4563 10.3568L41.1387 10.2158Z",
    fill: "url(#paint51_radial_578_447482)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2552 18.2283L41.4529 10.2603L45.1655 9.93714C46.4673 9.82733 47.7767 10.0871 48.9286 10.6965L50.8519 11.7141L53.5656 10.876C54.0502 10.7264 54.5784 10.7758 55.0223 11.0106L59.7355 13.5043L59.7746 13.4302L55.0402 10.9253C54.5964 10.6905 54.0576 10.6356 53.5836 10.7908L50.8699 11.6289L48.9466 10.6113C47.7947 10.0018 46.4747 9.73655 45.1835 9.85194L43.2386 10.0275L41.2906 10.1067L41.6584 9.20503L41.1279 10.2101L57.2552 18.2283Z",
    fill: "url(#paint52_radial_578_447482)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2558 14.3358C61.2617 14.3246 61.2617 14.3246 61.2558 14.3358C61.2728 14.3305 61.2558 14.3358 61.2558 14.3358Z",
    fill: "url(#paint53_radial_578_447482)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4657 10.3912L45.1955 10.2643C46.2239 10.1858 47.2512 10.391 48.1712 10.8507L58.4441 16.0016L57.584 17.6309C54.0843 15.8604 43.4011 10.4112 43.4657 10.3912Z",
    fill: "url(#paint54_radial_578_447482)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0463 12.0876L53.2065 11.3762L59.1773 14.5352L58.4847 15.8471L51.0463 12.0876Z",
    fill: "url(#paint55_radial_578_447482)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1712 10.1785L41.7017 9.17345L45.7679 8.8209C47.0697 8.7111 48.3791 8.97078 49.531 9.58022L51.4544 10.5978L54.168 9.75973C54.1842 9.75474 54.2165 9.74477 54.2432 9.74538C54.5284 9.66616 54.844 9.65722 55.1418 9.73352C55.1685 9.73413 55.1896 9.74536 55.2213 9.76213C55.2586 9.76833 55.2903 9.78508 55.3382 9.79686C55.4389 9.83661 55.5395 9.87631 55.6346 9.92663L60.369 12.4315L57.3085 18.2291L49.5041 14.3436L41.1712 10.1785Z",
    fill: "url(#paint56_linear_578_447482)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2386 18.26L41.4363 10.2919L45.1489 9.9688C46.4506 9.859 47.7601 10.1187 48.912 10.7281L50.8353 11.7457L53.549 10.9077C54.0336 10.7581 54.5618 10.8074 55.0057 11.0422L59.7189 13.5359L59.758 13.4618L55.0236 10.957C54.5798 10.7221 54.041 10.6672 53.567 10.8224L50.8533 11.6605L48.93 10.6429C47.7781 10.0334 46.4581 9.76816 45.1669 9.88356L43.222 10.0591L41.274 10.1383L41.6418 9.23664L41.1113 10.2417L57.2386 18.26Z",
    fill: "url(#paint57_radial_578_447482)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2607 20.5133L52.3922 21.1587L53.707 27.5774L64.5602 25.3542C68.4807 24.5534 71.9232 22.2225 74.1225 18.8877L75.7839 16.3657L75.6524 15.7202L52.2607 20.5133Z",
    fill: "url(#paint58_radial_578_447482)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2607 20.5133L75.6524 15.7202L73.991 18.2423C71.7797 21.5771 68.3493 23.9079 64.4287 24.7088L53.5756 26.932L52.2607 20.5133Z",
    fill: "url(#paint59_radial_578_447482)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2607 20.5133L75.6524 15.7202L73.991 18.2423C71.7797 21.5771 68.3493 23.9079 64.4287 24.7088L53.5756 26.932L52.2607 20.5133Z",
    fill: "url(#paint60_radial_578_447482)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6524 15.7202L52.2607 20.5133L52.2966 20.6687L75.2699 15.9712L73.6085 18.4933C72.4969 20.1786 71.0625 21.613 69.413 22.7126C71.2298 21.5771 72.7837 20.0591 73.991 18.2423L75.5687 15.8756L75.7839 16.3657L75.6524 15.7202Z",
    fill: "url(#paint61_radial_578_447482)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9903 24.5181L53.5635 26.8608L53.5754 26.9206L64.4286 24.6974C65.0501 24.5778 65.6597 24.4105 66.2454 24.2073C65.827 24.3388 65.4087 24.4463 64.9903 24.5181Z",
    fill: "url(#paint62_radial_578_447482)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1699 24.5416C65.1699 24.5416 68.6004 23.8723 71.5528 21.0634C71.5647 21.0753 69.449 23.191 65.1699 24.5416Z",
    fill: "url(#paint63_radial_578_447482)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2813 24.9481C65.2655 21.948 68.696 18.6968 71.0028 16.6768L64.5842 17.9916C62.7554 20.8602 59.1456 24.207 56.6953 26.2988L63.2813 24.9481Z",
    fill: "url(#paint64_radial_578_447482)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3739 18.1472L69.3538 20.1792C67.6326 21.9004 65.4931 23.0717 63.1623 23.5499L53.361 25.558L52.6318 21.9841L71.3739 18.1472Z",
    fill: "url(#paint65_radial_578_447482)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4691 18.075L69.3893 19.9874C67.6323 21.601 65.4449 22.7126 63.1022 23.2027L53.2172 25.2227L52.5479 21.9596L71.4691 18.075Z",
    fill: "url(#paint66_radial_578_447482)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1945 18.35L69.1626 20.2505C67.4294 21.8641 65.2898 22.9638 62.9829 23.4419L53.2534 25.4261L52.584 22.163L71.1945 18.35Z",
    fill: "url(#paint67_linear_578_447482)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3965 22.1871L70.4054 18.7089L70.2141 18.8762C68.8395 20.1313 67.1661 20.9919 65.3493 21.3624L53.6714 23.753L53.3965 22.1871Z",
    fill: "url(#paint68_radial_578_447482)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2607 20.5133L52.3922 21.1587L53.707 27.5774L64.5602 25.3542C68.4807 24.5534 71.9232 22.2225 74.1225 18.8877L75.7839 16.3657L75.6524 15.7202L52.2607 20.5133Z",
    fill: "url(#paint69_radial_578_447482)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4873 18.4334L48.7503 19.0908L51.3799 25.6409L62.4482 21.1945C66.4524 19.5809 69.6438 16.4493 71.3411 12.4809L72.608 9.49273L72.3451 8.83533L48.4873 18.4334Z",
    fill: "url(#paint70_radial_578_447482)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4873 18.4334L72.3571 8.83533L71.0901 11.8235C69.4047 15.7919 66.2014 18.9235 62.1972 20.5371L51.1289 24.9835L48.4873 18.4334Z",
    fill: "url(#paint71_radial_578_447482)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4873 18.4334L72.3571 8.83533L71.0901 11.8235C69.4047 15.7919 66.2014 18.9235 62.1972 20.5371L51.1289 24.9835L48.4873 18.4334Z",
    fill: "url(#paint72_radial_578_447482)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3571 8.83533L48.4873 18.4334L48.5471 18.6007L71.9985 9.16998L70.7315 12.1582C69.8709 14.1663 68.6398 15.9592 67.0978 17.4533C68.7951 15.8994 70.1578 13.987 71.0901 11.8235L72.3092 9.01462L72.632 9.49273L72.3571 8.83533Z",
    fill: "url(#paint73_radial_578_447482)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7587 20.2268L51.0928 24.9124L51.1167 24.984L62.185 20.5376C62.8185 20.2866 63.4281 19.9878 64.0138 19.665C63.6074 19.8682 63.1771 20.0476 62.7587 20.2268Z",
    fill: "url(#paint74_radial_578_447482)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9619 20.2144C62.9619 20.2144 66.4641 18.8399 69.0698 15.2899C69.0579 15.2899 67.2291 17.9434 62.9619 20.2144Z",
    fill: "url(#paint75_radial_578_447482)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0251 20.9917C62.555 17.4178 65.5552 13.3061 67.6111 10.7362L61.061 13.3658C59.6864 16.7724 56.495 21.0037 54.3076 23.693L61.0251 20.9917Z",
    fill: "url(#paint76_radial_578_447482)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2925 12.218L66.5473 14.7639C65.0652 16.9274 63.0093 18.5769 60.6427 19.5332L50.6381 23.5493L49.168 19.9037L68.2925 12.218Z",
    fill: "url(#paint77_radial_578_447482)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3761 12.1344L66.5473 14.5609C64.9934 16.6167 62.9017 18.2184 60.4992 19.1866L50.411 23.2386L49.0723 19.9037L68.3761 12.1344Z",
    fill: "url(#paint78_radial_578_447482)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1493 12.469L66.3683 14.8715C64.8503 16.9155 62.7944 18.5052 60.4277 19.4494L50.4949 23.4417L49.1562 20.1068L68.1493 12.469Z",
    fill: "url(#paint79_linear_578_447482)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0166 19.9874L67.3721 13.007L67.2048 13.2221C65.9975 14.8238 64.3719 16.0549 62.5192 16.796L50.6023 21.5891L50.0166 19.9874Z",
    fill: "url(#paint80_radial_578_447482)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5762 19.9067L43.8392 20.5641L46.4688 27.1142L57.537 22.6678C61.5412 21.0542 64.7327 17.9225 66.43 13.9542L67.6969 10.966L67.434 10.3086L43.5762 19.9067Z",
    fill: "url(#paint81_radial_578_447482)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7848 20.5133L40.6533 21.1587L39.3385 27.5774L28.4854 25.3542C24.5649 24.5534 21.1225 22.2225 18.9231 18.8877L17.2617 16.3657L17.3932 15.7202L40.7848 20.5133Z",
    fill: "url(#paint82_radial_578_447482)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7852 20.5134L17.3936 15.7203L19.055 18.2424C21.2663 21.5772 24.6968 23.908 28.6173 24.7089L39.4704 26.9321L40.7852 20.5134Z",
    fill: "url(#paint83_radial_578_447482)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7852 20.5134L17.3936 15.7203L19.055 18.2424C21.2663 21.5772 24.6968 23.908 28.6173 24.7089L39.4704 26.9321L40.7852 20.5134Z",
    fill: "url(#paint84_radial_578_447482)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3932 15.7202L40.7848 20.5133L40.749 20.6687L17.7757 15.9712L19.4371 18.4933C20.5487 20.1786 21.9831 21.613 23.6325 22.7126C21.8157 21.5771 20.2619 20.0591 19.0546 18.2423L17.4768 15.8756L17.2617 16.3657L17.3932 15.7202Z",
    fill: "url(#paint85_radial_578_447482)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0548 24.5181L39.4817 26.8608L39.4698 26.9206L28.6167 24.6974C27.9951 24.5778 27.3855 24.4105 26.7998 24.2073C27.2182 24.3388 27.6245 24.4463 28.0548 24.5181Z",
    fill: "url(#paint86_radial_578_447482)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8642 24.5416C27.8642 24.5416 24.4338 23.8723 21.4814 21.0634C21.4814 21.0753 23.5971 23.191 27.8642 24.5416Z",
    fill: "url(#paint87_radial_578_447482)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7528 24.9481C27.7686 21.948 24.3381 18.6968 22.0312 16.6768L28.4499 17.9916C30.2787 20.8602 33.8884 24.207 36.3387 26.2988L29.7528 24.9481Z",
    fill: "url(#paint88_radial_578_447482)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6611 18.1472L23.6811 20.1792C25.4023 21.9004 27.5419 23.0717 29.8727 23.5499L39.674 25.558L40.4031 21.9841L21.6611 18.1472Z",
    fill: "url(#paint89_radial_578_447482)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5771 18.075L23.657 19.9874C25.414 21.601 27.6014 22.7126 29.9441 23.2027L39.8291 25.2227L40.4985 21.9596L21.5771 18.075Z",
    fill: "url(#paint90_radial_578_447482)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8398 18.35L23.8718 20.2505C25.605 21.8641 27.7446 22.9638 30.0514 23.4419L39.781 25.4261L40.4504 22.163L21.8398 18.35Z",
    fill: "url(#paint91_linear_578_447482)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6377 22.1871L22.6289 18.7089L22.8202 18.8762C24.1947 20.1313 25.8681 20.9919 27.6849 21.3624L39.3628 23.753L39.6377 22.1871Z",
    fill: "url(#paint92_radial_578_447482)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7848 20.5133L40.6533 21.1587L39.3385 27.5774L28.4854 25.3542C24.5649 24.5534 21.1225 22.2225 18.9231 18.8877L17.2617 16.3657L17.3932 15.7202L40.7848 20.5133Z",
    fill: "url(#paint93_radial_578_447482)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5573 18.4335L44.2943 19.0909L41.6647 25.6411L30.5964 21.1946C26.5922 19.581 23.4008 16.4494 21.7035 12.4811L20.4365 9.49285L20.6995 8.83545L44.5573 18.4335Z",
    fill: "url(#paint94_radial_578_447482)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5572 18.4335L20.6875 8.83545L21.9545 11.8237C23.6399 15.792 26.8432 18.9236 30.8474 20.5372L41.9157 24.9836L44.5572 18.4335Z",
    fill: "url(#paint95_radial_578_447482)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5572 18.4335L20.6875 8.83545L21.9545 11.8237C23.6399 15.792 26.8432 18.9236 30.8474 20.5372L41.9157 24.9836L44.5572 18.4335Z",
    fill: "url(#paint96_radial_578_447482)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6882 8.83533L44.5579 18.4334L44.4982 18.6007L21.0348 9.16998L22.3019 12.1582C23.1625 14.1663 24.3936 15.9592 25.9355 17.4533C24.2382 15.8994 22.8756 13.987 21.9433 11.8235L20.7241 9.01462L20.4014 9.49273L20.6882 8.83533Z",
    fill: "url(#paint97_radial_578_447482)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2863 20.2268L41.9522 24.9124L41.9283 24.984L30.8601 20.5376C30.2266 20.2866 29.6169 19.9878 29.0312 19.665C29.4257 19.8682 29.856 20.0476 30.2863 20.2268Z",
    fill: "url(#paint98_radial_578_447482)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0835 20.2144C30.0835 20.2144 26.5813 18.8399 23.9756 15.2899C23.9756 15.2899 25.8044 17.9434 30.0835 20.2144Z",
    fill: "url(#paint99_radial_578_447482)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0068 20.9917C30.4769 17.4178 27.4768 13.3061 25.4209 10.7362L31.971 13.3658C33.3456 16.7724 36.537 21.0037 38.7243 23.693L32.0068 20.9917Z",
    fill: "url(#paint100_radial_578_447482)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.752 12.218L26.4971 14.7639C27.9792 16.9274 30.0351 18.5769 32.4137 19.5332L42.4182 23.5493L43.8884 19.9037L24.752 12.218Z",
    fill: "url(#paint101_radial_578_447482)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6562 12.1344L26.4851 14.5609C28.0389 16.6167 30.1307 18.2184 32.5332 19.1866L42.6214 23.2386L43.96 19.9037L24.6562 12.1344Z",
    fill: "url(#paint102_radial_578_447482)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8828 12.469L26.6638 14.8715C28.1818 16.9155 30.2376 18.5052 32.6043 19.4494L42.5371 23.4417L43.8758 20.1068L24.8828 12.469Z",
    fill: "url(#paint103_linear_578_447482)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0274 19.9874L25.6719 13.007L25.8393 13.2221C27.0465 14.8238 28.672 16.0549 30.5247 16.796L42.4417 21.5891L43.0274 19.9874Z",
    fill: "url(#paint104_radial_578_447482)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7135 20.6434L49.4506 21.3008L46.821 27.8509L35.7527 23.4045C31.7485 21.7909 28.5571 18.6592 26.8598 14.6909L25.5928 11.7027L25.8558 11.0453L49.7135 20.6434Z",
    fill: "url(#paint105_radial_578_447482)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3018 40.9784C37.3147 40.9977 37.3146 41.0229 37.3017 41.0422C37.0447 41.4275 36.7558 41.7967 36.4428 42.1418C36.4259 42.1587 36.409 42.1841 36.3836 42.2009C36.2905 42.3023 36.1889 42.4036 36.0874 42.5049C35.8504 42.7414 35.6135 42.9609 35.3511 43.1636C35.1154 43.3583 34.8719 43.5373 34.6131 43.7083C34.5937 43.7211 34.5686 43.7211 34.5494 43.7081C34.1412 43.4306 33.5007 42.8868 32.9639 42.3429C32.48 41.8528 31.9851 41.1891 31.8717 41.0348C31.8572 41.015 31.8569 40.9885 31.871 40.9684C31.9454 40.8619 32.1805 40.5276 32.3216 40.3516C32.5585 40.0561 32.8124 39.769 33.0747 39.4987C33.2186 39.3552 33.3624 39.2201 33.5148 39.085C33.8435 38.798 34.1882 38.5348 34.5488 38.2879C34.5683 38.2745 34.5939 38.2744 34.6135 38.2875C34.8813 38.4667 35.141 38.6541 35.385 38.857C35.6304 39.0596 35.8589 39.2707 36.0789 39.4903C36.5435 39.9621 36.9511 40.4502 37.3018 40.9784Z",
    fill: "#3E5F66"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6218 41.0073C36.4264 41.303 36.2058 41.5862 35.9663 41.8505C35.9537 41.863 35.9411 41.8819 35.9222 41.8945C35.8529 41.97 35.7772 42.0455 35.7016 42.121C35.5251 42.2972 35.3486 42.4608 35.1533 42.6119C34.9705 42.7629 34.7814 42.9013 34.5797 43.0335C34.2772 42.8321 33.9936 42.6119 33.7225 42.3727C33.2877 41.9826 32.9032 41.5421 32.5755 41.0513C32.5629 41.0324 32.5502 41.0198 32.5439 41.001C32.6574 40.8374 32.7708 40.6737 32.8969 40.5164C33.0734 40.2962 33.2625 40.0822 33.4578 39.8809C33.565 39.7739 33.6721 39.6732 33.7856 39.5725C34.0377 39.3523 34.3024 39.1509 34.5797 38.9622C34.7877 39.1006 34.9894 39.2453 35.1785 39.4026C35.3612 39.5537 35.5314 39.711 35.6953 39.8746C36.0482 40.2333 36.3571 40.6045 36.6218 41.0073Z",
    fill: "url(#paint106_radial_578_447482)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6217 41.0075H34.5859V38.9813C34.9893 39.2456 35.3675 39.5539 35.7078 39.8937C36.0482 40.2335 36.357 40.6048 36.6217 41.0075Z",
    fill: "url(#paint107_radial_578_447482)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5856 38.9813V41.0138H32.5498C32.8145 40.6111 33.1233 40.2335 33.4637 39.8937C33.8103 39.5539 34.1822 39.2456 34.5856 38.9813Z",
    fill: "url(#paint108_radial_578_447482)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5856 41.0074V43.04C33.7788 42.5051 33.0855 41.8129 32.5498 41.0074H34.5856Z",
    fill: "url(#paint109_radial_578_447482)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6217 41.0074C36.357 41.4102 36.0482 41.7877 35.7078 42.1275C35.3675 42.4673 34.9893 42.7757 34.5859 43.04V41.0074H36.6217Z",
    fill: "url(#paint110_radial_578_447482)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6208 41.0071C36.356 41.4098 36.0472 41.7874 35.7069 42.1272C35.3665 42.467 34.9884 42.7753 34.585 43.0396C34.2825 42.8383 34.1753 42.769 33.9043 42.5299L35.1837 39.4214C35.3665 39.5724 35.5367 39.7297 35.7006 39.8933C36.0472 40.2331 36.356 40.6044 36.6208 41.0071Z",
    fill: "url(#paint111_radial_578_447482)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9278 41.9003C35.8585 41.9758 35.7828 42.0514 35.7072 42.1269C35.3668 42.4667 34.9887 42.775 34.5853 43.0393C34.2828 42.8379 33.9992 42.6177 33.7281 42.3786C33.2933 41.9884 32.9088 41.548 32.5811 41.0571C33.4319 41.3088 34.6798 41.6549 35.9278 41.9003Z",
    fill: "url(#paint112_radial_578_447482)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9662 41.8506C35.9536 41.8632 35.941 41.8821 35.9221 41.8947C35.8527 41.9702 35.7771 42.0457 35.7015 42.1212C35.525 42.2974 35.3485 42.461 35.1531 42.612C34.6741 41.7625 34.1447 40.7431 34.1006 40.3467C34.1069 40.353 35.1657 41.2276 35.9662 41.8506Z",
    fill: "url(#paint113_radial_578_447482)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5861 41.0075L32.9033 40.523C33.0798 40.3028 33.2689 40.0888 33.4643 39.8874C33.5714 39.7805 33.6786 39.6798 33.792 39.5791L34.5861 41.0075Z",
    fill: "url(#paint114_radial_578_447482)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5866 42.3482C34.0572 41.9959 33.5971 41.5428 33.2441 41.0079C33.5971 40.4793 34.0509 40.02 34.5866 39.6676C35.116 40.02 35.5761 40.4731 35.9291 41.0079C35.5761 41.5428 35.1223 41.9959 34.5866 42.3482Z",
    fill: "url(#paint115_radial_578_447482)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9028 40.6171C33.0792 40.3969 33.2683 40.1829 33.4637 39.9816C33.5708 39.8746 33.678 39.7739 33.7914 39.6732C34.0435 39.453 34.3083 39.2516 34.5856 39.0628C34.7936 39.2013 34.9952 39.346 35.1843 39.5033C35.3671 39.6543 35.5373 39.8117 35.7011 39.9753C36.0289 40.3025 36.3251 40.6612 36.5835 41.045C36.5961 41.0261 36.6024 41.0135 36.615 40.9947C36.3503 40.5919 36.0415 40.2144 35.7011 39.8746C35.5373 39.711 35.3608 39.5537 35.1843 39.4026C34.9952 39.2453 34.7936 39.0943 34.5856 38.9622C34.3083 39.1446 34.0435 39.3523 33.7914 39.5725C33.678 39.6732 33.5708 39.7739 33.4637 39.8809C33.262 40.0822 33.0729 40.2899 32.9028 40.5164C32.7767 40.6737 32.6633 40.8374 32.5498 41.001C32.5624 41.0198 32.5687 41.0324 32.5813 41.0513C32.6885 40.9066 32.7956 40.7618 32.9028 40.6171Z",
    fill: "url(#paint116_radial_578_447482)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9663 41.7563C35.9537 41.7689 35.9411 41.7878 35.9222 41.8004C35.8529 41.8759 35.7772 41.9514 35.7016 42.0269C35.5251 42.2031 35.3486 42.3667 35.1533 42.5177C34.9705 42.6687 34.7814 42.8072 34.5797 42.9393C34.2772 42.738 33.9936 42.5177 33.7225 42.2786C33.2877 41.8885 32.9032 41.448 32.5755 40.9572C32.5629 40.976 32.5502 40.9886 32.5439 41.0075C32.5566 41.0264 32.5692 41.039 32.5755 41.0578C32.9032 41.5424 33.2877 41.9828 33.7225 42.3793C33.9873 42.6184 34.2772 42.8449 34.5797 43.04C34.7751 42.9079 34.9705 42.7694 35.1533 42.6184C35.3423 42.4611 35.5251 42.2975 35.7016 42.1276C35.7772 42.0521 35.8466 41.9766 35.9222 41.901C35.9348 41.8885 35.9474 41.8696 35.9663 41.857C36.2058 41.5927 36.4201 41.3095 36.6218 41.0138C36.6092 40.9949 36.5966 40.9823 36.5903 40.9634C36.4012 41.2403 36.1932 41.5046 35.9663 41.7563Z",
    fill: "url(#paint117_radial_578_447482)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4643 39.9813C33.2689 40.1827 33.0798 40.3966 32.9034 40.6169L32.6148 41.0066C32.9339 41.4741 33.305 41.8951 33.7225 42.2697C33.9936 42.5088 34.2772 42.7291 34.5797 42.9304C34.7814 42.7983 34.9705 42.6599 35.1533 42.5088C35.3486 42.3578 35.5251 42.1942 35.7016 42.018C35.7772 41.9425 35.8529 41.867 35.9222 41.7915C35.9351 41.7829 35.9451 41.7713 35.9541 41.7609C35.9583 41.756 35.9623 41.7514 35.9663 41.7474C36.1797 41.5107 36.3764 41.2628 36.5564 41.0038C36.3046 40.6354 36.0178 40.2906 35.7018 39.975C35.5379 39.8114 35.3677 39.6541 35.1849 39.5031C34.9959 39.3458 34.7942 39.201 34.5862 39.0626C34.3089 39.2514 34.0442 39.4527 33.792 39.673C33.6786 39.7737 33.5715 39.8743 33.4643 39.9813ZM36.5898 40.9553C36.3309 40.5672 36.0311 40.2031 35.7018 39.8743C35.5379 39.7107 35.3614 39.5534 35.1849 39.4024C34.9959 39.2451 34.7942 39.0941 34.5862 38.9619C34.3089 39.1444 34.0442 39.3521 33.792 39.5723C33.6786 39.673 33.5715 39.7737 33.4643 39.8806C33.2626 40.082 33.0735 40.2897 32.9034 40.5162C32.7886 40.6594 32.6844 40.8077 32.581 40.9566C32.5792 40.9538 32.5773 40.9511 32.5755 40.9483C32.5717 40.9539 32.5679 40.959 32.5643 40.9638C32.5559 40.9752 32.5484 40.9854 32.5439 40.9986C32.5477 41.0043 32.5515 41.0093 32.5551 41.0142C32.5635 41.0256 32.571 41.0357 32.5755 41.049C32.9032 41.5335 33.2877 41.974 33.7225 42.3704C33.9873 42.6095 34.2772 42.8361 34.5797 43.0311C34.7751 42.899 34.9705 42.7605 35.1533 42.6095C35.3423 42.4522 35.5251 42.2886 35.7016 42.1187C35.7394 42.0809 35.7757 42.0432 35.8119 42.0054C35.8481 41.9677 35.8844 41.9299 35.9222 41.8922C35.9262 41.8882 35.9302 41.8836 35.9344 41.8787C35.9434 41.8683 35.9534 41.8567 35.9663 41.8481C36.2058 41.5838 36.4201 41.3007 36.6218 41.0049C36.6195 41.0015 36.6173 40.9984 36.6151 40.9953C36.6153 40.995 36.6155 40.9947 36.6157 40.9944C36.6076 40.9822 36.5996 40.97 36.5915 40.9579C36.591 40.9568 36.5906 40.9557 36.5903 40.9546C36.5901 40.9548 36.5899 40.9551 36.5898 40.9553Z",
    fill: "url(#paint118_radial_578_447482)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5859 39.6727C34.5859 39.6727 35.3801 40.1698 35.9284 41.0131C35.9284 41.0068 35.5376 40.1384 34.5859 39.6727Z",
    fill: "url(#paint119_radial_578_447482)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 41.0081C33.25 41.0081 33.7227 41.8387 34.5231 42.3358L34.5862 42.9399L34.6303 42.3232C34.6303 42.3232 35.229 42.0715 35.9286 41.0081C35.9286 41.0081 35.0463 42.1911 34.5736 42.254C34.5736 42.2603 34.0252 42.0463 33.25 41.0081Z",
    fill: "url(#paint120_radial_578_447482)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5918 42.342C34.5918 42.342 35.4238 41.87 35.9217 41.0709L36.5267 41.0079L35.9091 40.9639C35.9091 40.9639 35.657 40.3661 34.5918 39.6676C34.5918 39.6676 35.7767 40.5486 35.8397 41.0205C35.846 41.0205 35.6317 41.568 34.5918 42.342Z",
    fill: "url(#paint121_radial_578_447482)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5609 39.6676C34.5609 39.6676 33.7289 40.1395 33.231 40.9387L32.626 41.0016L33.2436 41.0457C33.2436 41.0457 33.4957 41.6435 34.5609 42.342C34.5609 42.342 33.376 41.461 33.313 40.989C33.3067 40.989 33.521 40.4416 34.5609 39.6676Z",
    fill: "url(#paint122_radial_578_447482)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9286 41.0007C35.9286 41.0007 35.4559 40.1701 34.6555 39.6729L34.5925 39.0688L34.5484 39.6855C34.5484 39.6855 33.9496 39.9372 33.25 41.0007C33.25 41.0007 34.1324 39.8177 34.6051 39.7547C34.6051 39.7484 35.1534 39.9624 35.9286 41.0007Z",
    fill: "url(#paint123_radial_578_447482)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4395 44.2196C43.4524 44.2389 43.4523 44.2641 43.4394 44.2834C43.1824 44.6687 42.8935 45.0379 42.5805 45.383C42.5636 45.3999 42.5467 45.4253 42.5213 45.4422C42.4282 45.5435 42.3266 45.6448 42.2251 45.7462C41.9881 45.9826 41.7512 46.2022 41.4888 46.4048C41.2531 46.5995 41.0096 46.7786 40.7508 46.9495C40.7314 46.9623 40.7063 46.9624 40.6871 46.9493C40.2789 46.6718 39.6384 46.128 39.1016 45.5841C38.6177 45.094 38.1228 44.4303 38.0094 44.276C37.9949 44.2562 37.9946 44.2297 38.0087 44.2096C38.0831 44.1031 38.3182 43.7688 38.4593 43.5928C38.6962 43.2973 38.9501 43.0102 39.2124 42.74C39.3563 42.5964 39.5001 42.4613 39.6525 42.3262C39.9812 42.0392 40.3259 41.7761 40.6865 41.5291C40.706 41.5158 40.7316 41.5156 40.7512 41.5287C41.019 41.708 41.2787 41.8953 41.5227 42.0982C41.7681 42.3009 41.9966 42.512 42.2166 42.7315C42.6812 43.2034 43.0888 43.6914 43.4395 44.2196Z",
    fill: "#3E5F66"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7595 44.2485C42.5641 44.5442 42.3435 44.8274 42.104 45.0917C42.0914 45.1043 42.0788 45.1231 42.0599 45.1357C41.9906 45.2112 41.9149 45.2867 41.8393 45.3623C41.6628 45.5384 41.4863 45.7021 41.291 45.8531C41.1082 46.0041 40.9191 46.1425 40.7174 46.2747C40.4149 46.0733 40.1313 45.8531 39.8602 45.614C39.4254 45.2238 39.0409 44.7833 38.7132 44.2925C38.7005 44.2736 38.6879 44.261 38.6816 44.2422C38.7951 44.0786 38.9085 43.915 39.0346 43.7576C39.2111 43.5374 39.4001 43.3235 39.5955 43.1221C39.7027 43.0151 39.8098 42.9144 39.9233 42.8137C40.1754 42.5935 40.4401 42.3921 40.7174 42.2034C40.9254 42.3418 41.1271 42.4865 41.3162 42.6439C41.4989 42.7949 41.6691 42.9522 41.833 43.1158C42.1859 43.4745 42.4948 43.8457 42.7595 44.2485Z",
    fill: "url(#paint124_radial_578_447482)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7594 44.2488H40.7236V42.2225C41.127 42.4868 41.5052 42.7952 41.8455 43.135C42.1859 43.4748 42.4947 43.846 42.7594 44.2488Z",
    fill: "url(#paint125_radial_578_447482)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7233 42.2225V44.255H38.6875C38.9522 43.8523 39.261 43.4748 39.6014 43.135C39.948 42.7952 40.3199 42.4868 40.7233 42.2225Z",
    fill: "url(#paint126_radial_578_447482)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7233 44.2487V46.2812C39.9165 45.7463 39.2232 45.0541 38.6875 44.2487H40.7233Z",
    fill: "url(#paint127_radial_578_447482)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7594 44.2487C42.4947 44.6514 42.1859 45.0289 41.8455 45.3687C41.5052 45.7085 41.127 46.0169 40.7236 46.2812V44.2487H42.7594Z",
    fill: "url(#paint128_radial_578_447482)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7585 44.2483C42.4937 44.6511 42.1849 45.0286 41.8446 45.3684C41.5042 45.7082 41.1261 46.0166 40.7227 46.2808C40.4202 46.0795 40.313 46.0103 40.042 45.7711L41.3214 42.6626C41.5042 42.8136 41.6744 42.9709 41.8383 43.1345C42.1849 43.4743 42.4937 43.8456 42.7585 44.2483Z",
    fill: "url(#paint129_radial_578_447482)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0655 45.1415C41.9961 45.2171 41.9205 45.2926 41.8449 45.3681C41.5045 45.7079 41.1264 46.0162 40.723 46.2805C40.4205 46.0791 40.1369 45.8589 39.8658 45.6198C39.431 45.2296 39.0465 44.7892 38.7188 44.2983C39.5696 44.55 40.8175 44.8961 42.0655 45.1415Z",
    fill: "url(#paint130_radial_578_447482)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1039 45.0918C42.0913 45.1044 42.0787 45.1233 42.0598 45.1359C41.9904 45.2114 41.9148 45.2869 41.8392 45.3624C41.6627 45.5386 41.4862 45.7022 41.2908 45.8532C40.8118 45.0037 40.2824 43.9843 40.2383 43.5879C40.2446 43.5942 41.3034 44.4689 42.1039 45.0918Z",
    fill: "url(#paint131_radial_578_447482)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7238 44.2487L39.041 43.7642C39.2175 43.544 39.4066 43.33 39.602 43.1286C39.7091 43.0217 39.8162 42.921 39.9297 42.8203L40.7238 44.2487Z",
    fill: "url(#paint132_radial_578_447482)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7243 45.5895C40.1949 45.2371 39.7348 44.784 39.3818 44.2491C39.7348 43.7206 40.1886 43.2612 40.7243 42.9088C41.2537 43.2612 41.7138 43.7143 42.0668 44.2491C41.7138 44.784 41.26 45.2371 40.7243 45.5895Z",
    fill: "url(#paint133_radial_578_447482)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0404 43.8583C39.2169 43.6381 39.406 43.4241 39.6014 43.2228C39.7085 43.1158 39.8157 43.0151 39.9291 42.9144C40.1812 42.6942 40.4459 42.4928 40.7233 42.304C40.9313 42.4425 41.1329 42.5872 41.322 42.7445C41.5048 42.8956 41.675 43.0529 41.8388 43.2165C42.1666 43.5437 42.4628 43.9024 42.7212 44.2862C42.7338 44.2673 42.7401 44.2548 42.7527 44.2359C42.488 43.8332 42.1792 43.4556 41.8388 43.1158C41.675 42.9522 41.4985 42.7949 41.322 42.6439C41.1329 42.4865 40.9313 42.3355 40.7233 42.2034C40.4459 42.3859 40.1812 42.5935 39.9291 42.8137C39.8157 42.9144 39.7085 43.0151 39.6014 43.1221C39.3997 43.3234 39.2106 43.5311 39.0404 43.7576C38.9144 43.915 38.8009 44.0786 38.6875 44.2422C38.7001 44.261 38.7064 44.2736 38.719 44.2925C38.8262 44.1478 38.9333 44.0031 39.0404 43.8583Z",
    fill: "url(#paint134_radial_578_447482)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M42.104 44.9975C42.0914 45.0101 42.0788 45.029 42.0599 45.0416C41.9906 45.1171 41.9149 45.1926 41.8393 45.2681C41.6628 45.4443 41.4863 45.6079 41.291 45.7589C41.1082 45.91 40.9191 46.0484 40.7174 46.1805C40.4149 45.9792 40.1313 45.7589 39.8602 45.5198C39.4254 45.1297 39.0409 44.6892 38.7132 44.1984C38.7005 44.2172 38.6879 44.2298 38.6816 44.2487C38.6942 44.2676 38.7069 44.2802 38.7132 44.299C39.0409 44.7836 39.4254 45.2241 39.8602 45.6205C40.125 45.8596 40.4149 46.0861 40.7174 46.2812C40.9128 46.1491 41.1082 46.0106 41.291 45.8596C41.48 45.7023 41.6628 45.5387 41.8393 45.3688C41.9149 45.2933 41.9843 45.2178 42.0599 45.1423C42.0725 45.1297 42.0851 45.1108 42.104 45.0982C42.3435 44.8339 42.5578 44.5507 42.7595 44.255C42.7469 44.2361 42.7343 44.2235 42.728 44.2047C42.5389 44.4815 42.3309 44.7458 42.104 44.9975Z",
    fill: "url(#paint135_radial_578_447482)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.602 43.2225C39.4066 43.4239 39.2175 43.6378 39.0411 43.8581L38.7525 44.2478C39.0716 44.7153 39.4427 45.1363 39.8602 45.5109C40.1313 45.7501 40.4149 45.9703 40.7174 46.1717C40.9191 46.0395 41.1082 45.9011 41.291 45.7501C41.4863 45.599 41.6628 45.4354 41.8393 45.2592C41.9149 45.1837 41.9906 45.1082 42.0599 45.0327C42.0728 45.0241 42.0828 45.0126 42.0918 45.0021C42.096 44.9973 42.1 44.9926 42.104 44.9886C42.3174 44.7519 42.5141 44.504 42.6941 44.245C42.4423 43.8766 42.1555 43.5318 41.8395 43.2162C41.6756 43.0526 41.5054 42.8953 41.3226 42.7443C41.1336 42.587 40.9319 42.4422 40.7239 42.3038C40.4466 42.4926 40.1819 42.6939 39.9297 42.9142C39.8163 43.0149 39.7092 43.1156 39.602 43.2225ZM42.7275 44.1965C42.4686 43.8085 42.1688 43.4443 41.8395 43.1156C41.6756 42.9519 41.4991 42.7946 41.3226 42.6436C41.1336 42.4863 40.9319 42.3353 40.7239 42.2031C40.4466 42.3856 40.1819 42.5933 39.9297 42.8135C39.8163 42.9142 39.7092 43.0149 39.602 43.1218C39.4003 43.3232 39.2112 43.5309 39.0411 43.7574C38.9263 43.9006 38.8221 44.049 38.7187 44.1978C38.7169 44.195 38.715 44.1923 38.7132 44.1895C38.7094 44.1951 38.7056 44.2002 38.702 44.205C38.6936 44.2164 38.6861 44.2266 38.6816 44.2398C38.6854 44.2455 38.6892 44.2505 38.6928 44.2554C38.7012 44.2668 38.7087 44.2769 38.7132 44.2902C39.0409 44.7747 39.4254 45.2152 39.8602 45.6116C40.125 45.8507 40.4149 46.0773 40.7174 46.2723C40.9128 46.1402 41.1082 46.0018 41.291 45.8507C41.48 45.6934 41.6628 45.5298 41.8393 45.3599C41.8771 45.3222 41.9133 45.2844 41.9496 45.2466C41.9858 45.2089 42.0221 45.1711 42.0599 45.1334C42.0639 45.1294 42.0679 45.1248 42.0721 45.1199C42.0811 45.1095 42.0911 45.0979 42.104 45.0893C42.3435 44.825 42.5578 44.5419 42.7595 44.2461C42.7572 44.2427 42.755 44.2396 42.7528 44.2365C42.753 44.2362 42.7531 44.2359 42.7533 44.2356C42.7453 44.2234 42.7373 44.2112 42.7292 44.1991C42.7287 44.198 42.7283 44.1969 42.728 44.1958C42.7278 44.196 42.7276 44.1963 42.7275 44.1965Z",
    fill: "url(#paint136_radial_578_447482)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7236 42.9139C40.7236 42.9139 41.5178 43.4111 42.0661 44.2543C42.0661 44.248 41.6753 43.3796 40.7236 42.9139Z",
    fill: "url(#paint137_radial_578_447482)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3877 44.2493C39.3877 44.2493 39.8604 45.0799 40.6608 45.577L40.7239 46.1811L40.768 45.5644C40.768 45.5644 41.3667 45.3127 42.0663 44.2493C42.0663 44.2493 41.184 45.4323 40.7113 45.4952C40.7113 45.5015 40.1629 45.2875 39.3877 44.2493Z",
    fill: "url(#paint138_radial_578_447482)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7295 45.5832C40.7295 45.5832 41.5614 45.1112 42.0594 44.3121L42.6644 44.2491L42.0468 44.2051C42.0468 44.2051 41.7946 43.6073 40.7295 42.9088C40.7295 42.9088 41.9144 43.7898 41.9774 44.2617C41.9837 44.2617 41.7694 44.8092 40.7295 45.5832Z",
    fill: "url(#paint139_radial_578_447482)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6986 42.9088C40.6986 42.9088 39.8666 43.3808 39.3687 44.1799L38.7637 44.2428L39.3813 44.2869C39.3813 44.2869 39.6334 44.8847 40.6986 45.5832C40.6986 45.5832 39.5137 44.7022 39.4507 44.2303C39.4444 44.2303 39.6587 43.6828 40.6986 42.9088Z",
    fill: "url(#paint140_radial_578_447482)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0663 44.2419C42.0663 44.2419 41.5936 43.4113 40.7932 42.9141L40.7302 42.3101L40.686 42.9267C40.686 42.9267 40.0873 43.1784 39.3877 44.2419C39.3877 44.2419 40.2701 43.0589 40.7428 42.996C40.7428 42.9897 41.2911 43.2036 42.0663 44.2419Z",
    fill: "url(#paint141_radial_578_447482)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5948 44.2195C55.6076 44.2388 55.6076 44.2639 55.5947 44.2832C55.3376 44.6686 55.0487 45.0378 54.7358 45.3829C54.7189 45.3998 54.7019 45.4251 54.6765 45.442C54.5835 45.5434 54.4819 45.6447 54.3804 45.746C54.1434 45.9825 53.9065 46.202 53.6441 46.4047C53.4084 46.5994 53.1649 46.7784 52.906 46.9494C52.8866 46.9622 52.8616 46.9622 52.8424 46.9492C52.4341 46.6717 51.7937 46.1279 51.2568 45.584C50.773 45.0939 50.278 44.4302 50.1647 44.2759C50.1501 44.2561 50.1499 44.2296 50.164 44.2095C50.2384 44.1029 50.4735 43.7687 50.6145 43.5927C50.8515 43.2972 51.1054 43.0101 51.3677 42.7398C51.5116 42.5963 51.6554 42.4612 51.8077 42.3261C52.1365 42.0391 52.4811 41.7759 52.8418 41.529C52.8613 41.5156 52.8869 41.5155 52.9065 41.5286C53.1743 41.7078 53.4339 41.8951 53.678 42.0981C53.9234 42.3007 54.1519 42.5118 54.3719 42.7314C54.8364 43.2032 55.2441 43.6913 55.5948 44.2195Z",
    fill: "#3E5F66"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9148 44.2483C54.7194 44.5441 54.4988 44.8273 54.2593 45.0915C54.2467 45.1041 54.2341 45.123 54.2152 45.1356C54.1458 45.2111 54.0702 45.2866 53.9946 45.3621C53.8181 45.5383 53.6416 45.7019 53.4462 45.853C53.2634 46.004 53.0744 46.1424 52.8727 46.2746C52.5702 46.0732 52.2865 45.853 52.0155 45.6138C51.5806 45.2237 51.1962 44.7832 50.8684 44.2924C50.8558 44.2735 50.8432 44.2609 50.8369 44.242C50.9504 44.0784 51.0638 43.9148 51.1899 43.7575C51.3663 43.5373 51.5554 43.3233 51.7508 43.122C51.858 43.015 51.9651 42.9143 52.0785 42.8136C52.3307 42.5934 52.5954 42.392 52.8727 42.2032C53.0807 42.3417 53.2824 42.4864 53.4714 42.6437C53.6542 42.7948 53.8244 42.9521 53.9883 43.1157C54.3412 43.4744 54.65 43.8456 54.9148 44.2483Z",
    fill: "url(#paint142_radial_578_447482)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9147 44.2486H52.8789V42.2224C53.2823 42.4867 53.6604 42.795 54.0008 43.1348C54.3411 43.4746 54.65 43.8459 54.9147 44.2486Z",
    fill: "url(#paint143_radial_578_447482)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8785 42.2224V44.2549H50.8428C51.1075 43.8522 51.4163 43.4746 51.7567 43.1348C52.1033 42.795 52.4752 42.4867 52.8785 42.2224Z",
    fill: "url(#paint144_radial_578_447482)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8785 44.2485V46.281C52.0718 45.7462 51.3785 45.054 50.8428 44.2485H52.8785Z",
    fill: "url(#paint145_radial_578_447482)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9147 44.2485C54.65 44.6513 54.3411 45.0288 54.0008 45.3686C53.6604 45.7084 53.2823 46.0168 52.8789 46.281V44.2485H54.9147Z",
    fill: "url(#paint146_radial_578_447482)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9137 44.2482C54.649 44.6509 54.3402 45.0285 53.9998 45.3683C53.6595 45.7081 53.2813 46.0164 52.878 46.2807C52.5754 46.0794 52.4683 46.0101 52.1973 45.771L53.4767 42.6625C53.6595 42.8135 53.8297 42.9708 53.9935 43.1344C54.3402 43.4742 54.649 43.8455 54.9137 44.2482Z",
    fill: "url(#paint147_radial_578_447482)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2208 45.1414C54.1514 45.2169 54.0758 45.2924 54.0002 45.368C53.6598 45.7078 53.2817 46.0161 52.8783 46.2804C52.5757 46.079 52.2921 45.8588 52.0211 45.6197C51.5862 45.2295 51.2018 44.789 50.874 44.2982C51.7249 44.5499 52.9728 44.896 54.2208 45.1414Z",
    fill: "url(#paint148_radial_578_447482)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2592 45.0917C54.2465 45.1043 54.2339 45.1232 54.215 45.1357C54.1457 45.2113 54.0701 45.2868 53.9944 45.3623C53.818 45.5385 53.6415 45.7021 53.4461 45.8531C52.9671 45.0036 52.4377 43.9842 52.3936 43.5878C52.3999 43.5941 53.4587 44.4687 54.2592 45.0917Z",
    fill: "url(#paint149_radial_578_447482)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8791 44.2486L51.1963 43.7641C51.3728 43.5438 51.5618 43.3299 51.7572 43.1285C51.8644 43.0216 51.9715 42.9209 52.085 42.8202L52.8791 44.2486Z",
    fill: "url(#paint150_radial_578_447482)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8796 45.5893C52.3502 45.237 51.8901 44.7839 51.5371 44.249C51.8901 43.7204 52.3439 43.2611 52.8796 42.9087C53.409 43.2611 53.8691 43.7141 54.2221 44.249C53.8691 44.7839 53.4153 45.237 52.8796 45.5893Z",
    fill: "url(#paint151_radial_578_447482)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1957 43.8582C51.3722 43.638 51.5613 43.424 51.7567 43.2226C51.8638 43.1157 51.971 43.015 52.0844 42.9143C52.3365 42.6941 52.6012 42.4927 52.8785 42.3039C53.0865 42.4424 53.2882 42.5871 53.4773 42.7444C53.6601 42.8954 53.8302 43.0527 53.9941 43.2164C54.3219 43.5436 54.6181 43.9022 54.8765 44.2861C54.8891 44.2672 54.8954 44.2546 54.908 44.2358C54.6433 43.833 54.3345 43.4555 53.9941 43.1157C53.8302 42.9521 53.6538 42.7948 53.4773 42.6437C53.2882 42.4864 53.0865 42.3354 52.8785 42.2032C52.6012 42.3857 52.3365 42.5934 52.0844 42.8136C51.971 42.9143 51.8638 43.015 51.7567 43.122C51.555 43.3233 51.3659 43.531 51.1957 43.7575C51.0697 43.9148 50.9562 44.0784 50.8428 44.242C50.8554 44.2609 50.8617 44.2735 50.8743 44.2924C50.9814 44.1477 51.0886 44.0029 51.1957 43.8582Z",
    fill: "url(#paint152_radial_578_447482)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2593 44.9974C54.2467 45.01 54.2341 45.0289 54.2152 45.0414C54.1458 45.117 54.0702 45.1925 53.9946 45.268C53.8181 45.4442 53.6416 45.6078 53.4462 45.7588C53.2634 45.9098 53.0744 46.0483 52.8727 46.1804C52.5702 45.979 52.2865 45.7588 52.0155 45.5197C51.5806 45.1295 51.1962 44.6891 50.8684 44.1982C50.8558 44.2171 50.8432 44.2297 50.8369 44.2486C50.8495 44.2675 50.8621 44.28 50.8684 44.2989C51.1962 44.7835 51.5806 45.2239 52.0155 45.6204C52.2802 45.8595 52.5702 46.086 52.8727 46.2811C53.0681 46.1489 53.2634 46.0105 53.4462 45.8595C53.6353 45.7022 53.8181 45.5386 53.9946 45.3687C54.0702 45.2932 54.1395 45.2176 54.2152 45.1421C54.2278 45.1295 54.2404 45.1107 54.2593 45.0981C54.4988 44.8338 54.7131 44.5506 54.9148 44.2549C54.9021 44.236 54.8895 44.2234 54.8832 44.2045C54.6942 44.4814 54.4862 44.7457 54.2593 44.9974Z",
    fill: "url(#paint153_radial_578_447482)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7573 43.2224C51.5619 43.4238 51.3728 43.6377 51.1963 43.858L50.9078 44.2477C51.2268 44.7152 51.5979 45.1362 52.0155 45.5108C52.2865 45.7499 52.5702 45.9702 52.8727 46.1715C53.0744 46.0394 53.2634 45.901 53.4462 45.7499C53.6416 45.5989 53.8181 45.4353 53.9946 45.2591C54.0702 45.1836 54.1458 45.1081 54.2152 45.0326C54.2281 45.024 54.2381 45.0124 54.2471 45.002C54.2513 44.9971 54.2553 44.9925 54.2593 44.9885C54.4727 44.7518 54.6694 44.5039 54.8493 44.2449C54.5975 43.8765 54.3108 43.5317 53.9947 43.2161C53.8309 43.0525 53.6607 42.8952 53.4779 42.7442C53.2888 42.5869 53.0871 42.4421 52.8792 42.3037C52.6018 42.4925 52.3371 42.6938 52.085 42.9141C51.9716 43.0147 51.8644 43.1154 51.7573 43.2224ZM54.8827 44.1964C54.6238 43.8083 54.324 43.4442 53.9947 43.1154C53.8309 42.9518 53.6544 42.7945 53.4779 42.6435C53.2888 42.4862 53.0871 42.3351 52.8792 42.203C52.6018 42.3855 52.3371 42.5931 52.085 42.8134C51.9716 42.9141 51.8644 43.0147 51.7573 43.1217C51.5556 43.3231 51.3665 43.5307 51.1963 43.7573C51.0816 43.9004 50.9773 44.0488 50.874 44.1977C50.8721 44.1949 50.8703 44.1921 50.8684 44.1894C50.8647 44.195 50.8609 44.2001 50.8573 44.2049C50.8489 44.2163 50.8413 44.2265 50.8369 44.2397C50.8407 44.2453 50.8444 44.2504 50.848 44.2553C50.8565 44.2667 50.864 44.2768 50.8684 44.29C51.1962 44.7746 51.5806 45.2151 52.0155 45.6115C52.2802 45.8506 52.5702 46.0771 52.8727 46.2722C53.0681 46.1401 53.2634 46.0016 53.4462 45.8506C53.6353 45.6933 53.8181 45.5297 53.9946 45.3598C54.0324 45.322 54.0686 45.2843 54.1049 45.2465C54.1411 45.2088 54.1773 45.171 54.2152 45.1333C54.2191 45.1293 54.2231 45.1247 54.2273 45.1198C54.2364 45.1093 54.2464 45.0978 54.2593 45.0892C54.4988 44.8249 54.7131 44.5418 54.9148 44.246C54.9125 44.2426 54.9102 44.2394 54.908 44.2364C54.9082 44.2361 54.9084 44.2358 54.9086 44.2355C54.9006 44.2233 54.8925 44.2111 54.8844 44.199C54.884 44.1979 54.8836 44.1968 54.8832 44.1957C54.8831 44.1959 54.8829 44.1962 54.8827 44.1964Z",
    fill: "url(#paint154_radial_578_447482)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8789 42.9138C52.8789 42.9138 53.673 43.4109 54.2214 44.2541C54.2214 44.2478 53.8306 43.3795 52.8789 42.9138Z",
    fill: "url(#paint155_radial_578_447482)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M51.543 44.2491C51.543 44.2491 52.0157 45.0798 52.8161 45.5769L52.8791 46.181L52.9233 45.5643C52.9233 45.5643 53.522 45.3126 54.2216 44.2491C54.2216 44.2491 53.3392 45.4322 52.8665 45.4951C52.8665 45.5014 52.3182 45.2874 51.543 44.2491Z",
    fill: "url(#paint156_radial_578_447482)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8848 45.583C52.8848 45.583 53.7167 45.1111 54.2146 44.3119L54.8197 44.249L54.202 44.205C54.202 44.205 53.9499 43.6072 52.8848 42.9087C52.8848 42.9087 54.0697 43.7897 54.1327 44.2616C54.139 44.2616 53.9247 44.8091 52.8848 45.583Z",
    fill: "url(#paint157_radial_578_447482)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8539 42.9087C52.8539 42.9087 52.0219 43.3806 51.524 44.1798L50.9189 44.2427L51.5366 44.2868C51.5366 44.2868 51.7887 44.8846 52.8539 45.583C52.8539 45.583 51.669 44.7021 51.6059 44.2301C51.5996 44.2301 51.8139 43.6827 52.8539 42.9087Z",
    fill: "url(#paint158_radial_578_447482)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2216 44.2418C54.2216 44.2418 53.7489 43.4111 52.9485 42.914L52.8854 42.3099L52.8413 42.9266C52.8413 42.9266 52.2426 43.1783 51.543 44.2418C51.543 44.2418 52.4253 43.0588 52.898 42.9958C52.898 42.9895 53.4464 43.2035 54.2216 44.2418Z",
    fill: "url(#paint159_radial_578_447482)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6592 40.9784C61.6721 40.9977 61.672 41.0229 61.6592 41.0422C61.4021 41.4275 61.1132 41.7967 60.8002 42.1418C60.7833 42.1587 60.7664 42.1841 60.741 42.2009C60.6479 42.3023 60.5464 42.4036 60.4448 42.5049C60.2079 42.7414 59.9709 42.9609 59.7086 43.1636C59.4728 43.3583 59.2293 43.5373 58.9705 43.7083C58.9511 43.7211 58.926 43.7211 58.9068 43.7081C58.4986 43.4306 57.8581 42.8868 57.3213 42.3429C56.8374 41.8528 56.3425 41.1891 56.2292 41.0348C56.2146 41.015 56.2143 40.9885 56.2284 40.9684C56.3028 40.8619 56.5379 40.5276 56.679 40.3516C56.9159 40.0561 57.1698 39.769 57.4321 39.4987C57.576 39.3552 57.7199 39.2201 57.8722 39.085C58.2009 38.798 58.5456 38.5348 58.9062 38.2879C58.9257 38.2745 58.9513 38.2744 58.971 38.2875C59.2387 38.4667 59.4984 38.6541 59.7424 38.857C59.9878 39.0596 60.2163 39.2707 60.4363 39.4903C60.9009 39.9621 61.3085 40.4502 61.6592 40.9784Z",
    fill: "#3E5F66"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9792 41.0073C60.7838 41.303 60.5632 41.5862 60.3237 41.8505C60.3111 41.863 60.2985 41.8819 60.2796 41.8945C60.2103 41.97 60.1346 42.0455 60.059 42.121C59.8825 42.2972 59.7061 42.4608 59.5107 42.6119C59.3279 42.7629 59.1388 42.9013 58.9371 43.0335C58.6346 42.8321 58.351 42.6119 58.08 42.3727C57.6451 41.9826 57.2606 41.5421 56.9329 41.0513C56.9203 41.0324 56.9077 41.0198 56.9014 41.001C57.0148 40.8374 57.1283 40.6737 57.2543 40.5164C57.4308 40.2962 57.6199 40.0822 57.8153 39.8809C57.9224 39.7739 58.0295 39.6732 58.143 39.5725C58.3951 39.3523 58.6598 39.1509 58.9371 38.9622C59.1451 39.1006 59.3468 39.2453 59.5359 39.4026C59.7187 39.5537 59.8888 39.711 60.0527 39.8746C60.4057 40.2333 60.7145 40.6045 60.9792 41.0073Z",
    fill: "url(#paint160_radial_578_447482)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9791 41.0075H58.9434V38.9813C59.3467 39.2456 59.7249 39.5539 60.0652 39.8937C60.4056 40.2335 60.7144 40.6048 60.9791 41.0075Z",
    fill: "url(#paint161_radial_578_447482)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M58.943 38.9813V41.0138H56.9072C57.1719 40.6111 57.4808 40.2335 57.8211 39.8937C58.1678 39.5539 58.5396 39.2456 58.943 38.9813Z",
    fill: "url(#paint162_radial_578_447482)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M58.943 41.0074V43.04C58.1363 42.5051 57.443 41.8129 56.9072 41.0074H58.943Z",
    fill: "url(#paint163_radial_578_447482)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9791 41.0074C60.7144 41.4102 60.4056 41.7877 60.0652 42.1275C59.7249 42.4673 59.3467 42.7757 58.9434 43.04V41.0074H60.9791Z",
    fill: "url(#paint164_radial_578_447482)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9782 41.0071C60.7135 41.4098 60.4046 41.7874 60.0643 42.1272C59.7239 42.467 59.3458 42.7753 58.9424 43.0396C58.6399 42.8383 58.5327 42.769 58.2617 42.5299L59.5412 39.4214C59.7239 39.5724 59.8941 39.7297 60.058 39.8933C60.4046 40.2331 60.7135 40.6044 60.9782 41.0071Z",
    fill: "url(#paint165_radial_578_447482)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2852 41.9003C60.2159 41.9758 60.1402 42.0514 60.0646 42.1269C59.7243 42.4667 59.3461 42.775 58.9427 43.0393C58.6402 42.8379 58.3566 42.6177 58.0856 42.3786C57.6507 41.9884 57.2662 41.548 56.9385 41.0571C57.7893 41.3088 59.0373 41.6549 60.2852 41.9003Z",
    fill: "url(#paint166_radial_578_447482)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3236 41.8506C60.311 41.8632 60.2984 41.8821 60.2795 41.8947C60.2102 41.9702 60.1345 42.0457 60.0589 42.1212C59.8824 42.2974 59.7059 42.461 59.5106 42.612C59.0316 41.7625 58.5021 40.7431 58.458 40.3467C58.4643 40.353 59.5232 41.2276 60.3236 41.8506Z",
    fill: "url(#paint167_radial_578_447482)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9436 41.0075L57.2607 40.523C57.4372 40.3028 57.6263 40.0888 57.8217 39.8874C57.9288 39.7805 58.036 39.6798 58.1494 39.5791L58.9436 41.0075Z",
    fill: "url(#paint168_radial_578_447482)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M58.944 42.3482C58.4146 41.9959 57.9545 41.5428 57.6016 41.0079C57.9545 40.4793 58.4083 40.02 58.944 39.6676C59.4735 40.02 59.9336 40.4731 60.2865 41.0079C59.9336 41.5428 59.4798 41.9959 58.944 42.3482Z",
    fill: "url(#paint169_radial_578_447482)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2602 40.6171C57.4367 40.3969 57.6257 40.1829 57.8211 39.9816C57.9283 39.8746 58.0354 39.7739 58.1489 39.6732C58.401 39.453 58.6657 39.2516 58.943 39.0628C59.151 39.2013 59.3527 39.346 59.5418 39.5033C59.7245 39.6543 59.8947 39.8117 60.0586 39.9753C60.3863 40.3025 60.6825 40.6612 60.9409 41.045C60.9536 41.0261 60.9599 41.0135 60.9725 40.9947C60.7077 40.5919 60.3989 40.2144 60.0586 39.8746C59.8947 39.711 59.7182 39.5537 59.5418 39.4026C59.3527 39.2453 59.151 39.0943 58.943 38.9622C58.6657 39.1446 58.401 39.3523 58.1489 39.5725C58.0354 39.6732 57.9283 39.7739 57.8211 39.8809C57.6194 40.0822 57.4303 40.2899 57.2602 40.5164C57.1341 40.6737 57.0207 40.8374 56.9072 41.001C56.9198 41.0198 56.9261 41.0324 56.9387 41.0513C57.0459 40.9066 57.153 40.7618 57.2602 40.6171Z",
    fill: "url(#paint170_radial_578_447482)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3237 41.7563C60.3111 41.7689 60.2985 41.7878 60.2796 41.8004C60.2103 41.8759 60.1346 41.9514 60.059 42.0269C59.8825 42.2031 59.7061 42.3667 59.5107 42.5177C59.3279 42.6687 59.1388 42.8072 58.9371 42.9393C58.6346 42.738 58.351 42.5177 58.08 42.2786C57.6451 41.8885 57.2606 41.448 56.9329 40.9572C56.9203 40.976 56.9077 40.9886 56.9014 41.0075C56.914 41.0264 56.9266 41.039 56.9329 41.0578C57.2606 41.5424 57.6451 41.9828 58.08 42.3793C58.3447 42.6184 58.6346 42.8449 58.9371 43.04C59.1325 42.9079 59.3279 42.7694 59.5107 42.6184C59.6998 42.4611 59.8825 42.2975 60.059 42.1276C60.1346 42.0521 60.204 41.9766 60.2796 41.901C60.2922 41.8885 60.3048 41.8696 60.3237 41.857C60.5632 41.5927 60.7775 41.3095 60.9792 41.0138C60.9666 40.9949 60.954 40.9823 60.9477 40.9634C60.7586 41.2403 60.5506 41.5046 60.3237 41.7563Z",
    fill: "url(#paint171_radial_578_447482)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8217 39.9813C57.6263 40.1827 57.4373 40.3966 57.2608 40.6169L56.9723 41.0066C57.2913 41.4741 57.6624 41.8951 58.08 42.2697C58.351 42.5088 58.6346 42.7291 58.9371 42.9304C59.1388 42.7983 59.3279 42.6599 59.5107 42.5088C59.7061 42.3578 59.8825 42.1942 60.059 42.018C60.1346 41.9425 60.2103 41.867 60.2796 41.7915C60.2925 41.7829 60.3025 41.7713 60.3116 41.7609C60.3157 41.756 60.3197 41.7514 60.3237 41.7474C60.5371 41.5107 60.7338 41.2628 60.9138 41.0038C60.662 40.6354 60.3752 40.2906 60.0592 39.975C59.8953 39.8114 59.7251 39.6541 59.5424 39.5031C59.3533 39.3458 59.1516 39.201 58.9436 39.0626C58.6663 39.2514 58.4016 39.4527 58.1495 39.673C58.036 39.7737 57.9289 39.8743 57.8217 39.9813ZM60.9472 40.9553C60.6883 40.5672 60.3885 40.2031 60.0592 39.8743C59.8953 39.7107 59.7188 39.5534 59.5424 39.4024C59.3533 39.2451 59.1516 39.0941 58.9436 38.9619C58.6663 39.1444 58.4016 39.3521 58.1495 39.5723C58.036 39.673 57.9289 39.7737 57.8217 39.8806C57.62 40.082 57.431 40.2897 57.2608 40.5162C57.1461 40.6594 57.0418 40.8077 56.9384 40.9566C56.9366 40.9538 56.9347 40.9511 56.9329 40.9483C56.9291 40.9539 56.9254 40.959 56.9218 40.9638C56.9133 40.9752 56.9058 40.9854 56.9014 40.9986C56.9051 41.0043 56.9089 41.0093 56.9125 41.0142C56.9209 41.0256 56.9285 41.0357 56.9329 41.049C57.2606 41.5335 57.6451 41.974 58.08 42.3704C58.3447 42.6095 58.6346 42.8361 58.9371 43.0311C59.1325 42.899 59.3279 42.7605 59.5107 42.6095C59.6998 42.4522 59.8825 42.2886 60.059 42.1187C60.0968 42.0809 60.1331 42.0432 60.1693 42.0054C60.2056 41.9677 60.2418 41.9299 60.2796 41.8922C60.2836 41.8882 60.2876 41.8836 60.2918 41.8787C60.3008 41.8683 60.3108 41.8567 60.3237 41.8481C60.5632 41.5838 60.7775 41.3007 60.9792 41.0049C60.977 41.0015 60.9747 40.9984 60.9725 40.9953C60.9727 40.995 60.9729 40.9947 60.9731 40.9944C60.9651 40.9822 60.957 40.97 60.9489 40.9579C60.9485 40.9568 60.9481 40.9557 60.9477 40.9546C60.9475 40.9548 60.9474 40.9551 60.9472 40.9553Z",
    fill: "url(#paint172_radial_578_447482)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9434 39.6727C58.9434 39.6727 59.7375 40.1698 60.2858 41.0131C60.2858 41.0068 59.8951 40.1384 58.9434 39.6727Z",
    fill: "url(#paint173_radial_578_447482)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6074 41.0081C57.6074 41.0081 58.0801 41.8387 58.8806 42.3358L58.9436 42.9399L58.9877 42.3232C58.9877 42.3232 59.5865 42.0715 60.2861 41.0081C60.2861 41.0081 59.4037 42.1911 58.931 42.254C58.931 42.2603 58.3827 42.0463 57.6074 41.0081Z",
    fill: "url(#paint174_radial_578_447482)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9492 42.342C58.9492 42.342 59.7812 41.87 60.2791 41.0709L60.8841 41.0079L60.2665 40.9639C60.2665 40.9639 60.0144 40.3661 58.9492 39.6676C58.9492 39.6676 60.1341 40.5486 60.1972 41.0205C60.2035 41.0205 59.9892 41.568 58.9492 42.342Z",
    fill: "url(#paint175_radial_578_447482)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9183 39.6676C58.9183 39.6676 58.0864 40.1395 57.5885 40.9387L56.9834 41.0016L57.6011 41.0457C57.6011 41.0457 57.8532 41.6435 58.9183 42.342C58.9183 42.342 57.7334 41.461 57.6704 40.989C57.6641 40.989 57.8784 40.4416 58.9183 39.6676Z",
    fill: "url(#paint176_radial_578_447482)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2861 41.0007C60.2861 41.0007 59.8134 40.1701 59.0129 39.6729L58.9499 39.0688L58.9058 39.6855C58.9058 39.6855 58.307 39.9372 57.6074 41.0007C57.6074 41.0007 58.4898 39.8177 58.9625 39.7547C58.9625 39.7484 59.5108 39.9624 60.2861 41.0007Z",
    fill: "url(#paint177_radial_578_447482)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5294 46.7977C49.5422 46.817 49.5422 46.8422 49.5293 46.8615C49.2722 47.2469 48.9833 47.616 48.6703 47.9612C48.6534 47.9781 48.6365 48.0034 48.6111 48.0203C48.518 48.1216 48.4165 48.2229 48.3149 48.3243C48.078 48.5607 47.841 48.7803 47.5787 48.9829C47.343 49.1776 47.0994 49.3567 46.8406 49.5277C46.8212 49.5405 46.7962 49.5405 46.7769 49.5274C46.3687 49.25 45.7282 48.7061 45.1914 48.1623C44.7075 47.6721 44.2126 47.0085 44.0993 46.8542C44.0847 46.8343 44.0844 46.8079 44.0985 46.7877C44.173 46.6812 44.408 46.3469 44.5491 46.171C44.786 45.8754 45.0399 45.5883 45.3023 45.3181C45.4461 45.1745 45.59 45.0394 45.7423 44.9043C46.071 44.6173 46.4157 44.3542 46.7763 44.1072C46.7958 44.0939 46.8215 44.0937 46.8411 44.1069C47.1088 44.2861 47.3685 44.4734 47.6125 44.6763C47.8579 44.879 48.0864 45.0901 48.3065 45.3096C48.771 45.7815 49.1786 46.2695 49.5294 46.7977Z",
    fill: "#3E5F66"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8493 46.8266C48.6539 47.1223 48.4333 47.4055 48.1938 47.6698C48.1812 47.6824 48.1686 47.7013 48.1497 47.7138C48.0804 47.7894 48.0048 47.8649 47.9291 47.9404C47.7527 48.1166 47.5762 48.2802 47.3808 48.4312C47.198 48.5822 47.0089 48.7207 46.8073 48.8528C46.5047 48.6514 46.2211 48.4312 45.9501 48.1921C45.5152 47.8019 45.1307 47.3615 44.803 46.8706C44.7904 46.8518 44.7778 46.8392 44.7715 46.8203C44.8849 46.6567 44.9984 46.4931 45.1244 46.3358C45.3009 46.1155 45.49 45.9016 45.6854 45.7002C45.7925 45.5932 45.8997 45.4926 46.0131 45.3919C46.2652 45.1716 46.5299 44.9703 46.8073 44.7815C47.0152 44.9199 47.2169 45.0647 47.406 45.222C47.5888 45.373 47.759 45.5303 47.9228 45.6939C48.2758 46.0526 48.5846 46.4239 48.8493 46.8266Z",
    fill: "url(#paint178_radial_578_447482)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8492 46.8269H46.8135V44.8007C47.2168 45.0649 47.595 45.3733 47.9354 45.7131C48.2757 46.0529 48.5845 46.4241 48.8492 46.8269Z",
    fill: "url(#paint179_radial_578_447482)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8131 44.8007V46.8332H44.7773C45.0421 46.4304 45.3509 46.0529 45.6912 45.7131C46.0379 45.3733 46.4097 45.0649 46.8131 44.8007Z",
    fill: "url(#paint180_radial_578_447482)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8131 46.8268V48.8593C46.0064 48.3244 45.3131 47.6322 44.7773 46.8268H46.8131Z",
    fill: "url(#paint181_radial_578_447482)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8492 46.8268C48.5845 47.2295 48.2757 47.6071 47.9354 47.9469C47.595 48.2867 47.2168 48.595 46.8135 48.8593V46.8268H48.8492Z",
    fill: "url(#paint182_radial_578_447482)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8483 46.8265C48.5836 47.2292 48.2747 47.6067 47.9344 47.9465C47.5941 48.2863 47.2159 48.5947 46.8125 48.859C46.51 48.6576 46.4029 48.5884 46.1318 48.3493L47.4113 45.2407C47.5941 45.3917 47.7642 45.5491 47.9281 45.7127C48.2748 46.0525 48.5836 46.4237 48.8483 46.8265Z",
    fill: "url(#paint183_radial_578_447482)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1553 47.7197C48.086 47.7952 48.0104 47.8707 47.9347 47.9462C47.5944 48.286 47.2162 48.5943 46.8128 48.8586C46.5103 48.6573 46.2267 48.437 45.9557 48.1979C45.5208 47.8078 45.1363 47.3673 44.8086 46.8765C45.6595 47.1282 46.9074 47.4743 48.1553 47.7197Z",
    fill: "url(#paint184_radial_578_447482)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1937 47.6699C48.1811 47.6825 48.1685 47.7014 48.1496 47.714C48.0803 47.7895 48.0046 47.865 47.929 47.9405C47.7525 48.1167 47.5761 48.2803 47.3807 48.4314C46.9017 47.5819 46.3722 46.5624 46.3281 46.166C46.3344 46.1723 47.3933 47.047 48.1937 47.6699Z",
    fill: "url(#paint185_radial_578_447482)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8137 46.8269L45.1309 46.3423C45.3073 46.1221 45.4964 45.9081 45.6918 45.7068C45.7989 45.5998 45.9061 45.4991 46.0195 45.3984L46.8137 46.8269Z",
    fill: "url(#paint186_radial_578_447482)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8142 48.1676C46.2847 47.8152 45.8246 47.3621 45.4717 46.8273C45.8246 46.2987 46.2784 45.8393 46.8142 45.4869C47.3436 45.8393 47.8037 46.2924 48.1566 46.8273C47.8037 47.3621 47.3499 47.8152 46.8142 48.1676Z",
    fill: "url(#paint187_radial_578_447482)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1303 46.4364C45.3068 46.2162 45.4959 46.0023 45.6912 45.8009C45.7984 45.6939 45.9055 45.5932 46.019 45.4926C46.2711 45.2723 46.5358 45.071 46.8131 44.8822C47.0211 45.0206 47.2228 45.1653 47.4119 45.3227C47.5946 45.4737 47.7648 45.631 47.9287 45.7946C48.2564 46.1218 48.5527 46.4805 48.8111 46.8643C48.8237 46.8455 48.83 46.8329 48.8426 46.814C48.5779 46.4113 48.269 46.0337 47.9287 45.6939C47.7648 45.5303 47.5883 45.373 47.4119 45.222C47.2228 45.0647 47.0211 44.9136 46.8131 44.7815C46.5358 44.964 46.2711 45.1716 46.019 45.3919C45.9055 45.4926 45.7984 45.5932 45.6912 45.7002C45.4895 45.9016 45.3005 46.1092 45.1303 46.3358C45.0042 46.4931 44.8908 46.6567 44.7773 46.8203C44.7899 46.8392 44.7963 46.8518 44.8089 46.8706C44.916 46.7259 45.0231 46.5812 45.1303 46.4364Z",
    fill: "url(#paint188_radial_578_447482)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1938 47.5756C48.1812 47.5882 48.1686 47.6071 48.1497 47.6197C48.0804 47.6952 48.0048 47.7707 47.9291 47.8462C47.7527 48.0224 47.5762 48.186 47.3808 48.3371C47.198 48.4881 47.0089 48.6265 46.8073 48.7587C46.5047 48.5573 46.2211 48.3371 45.9501 48.0979C45.5152 47.7078 45.1307 47.2673 44.803 46.7765C44.7904 46.7954 44.7778 46.808 44.7715 46.8268C44.7841 46.8457 44.7967 46.8583 44.803 46.8772C45.1307 47.3617 45.5152 47.8022 45.9501 48.1986C46.2148 48.4377 46.5047 48.6643 46.8073 48.8593C47.0026 48.7272 47.198 48.5888 47.3808 48.4377C47.5699 48.2804 47.7527 48.1168 47.9291 47.9469C48.0048 47.8714 48.0741 47.7959 48.1497 47.7204C48.1623 47.7078 48.1749 47.6889 48.1938 47.6763C48.4333 47.412 48.6476 47.1289 48.8493 46.8331C48.8367 46.8142 48.8241 46.8017 48.8178 46.7828C48.6287 47.0597 48.4207 47.3239 48.1938 47.5756Z",
    fill: "url(#paint189_radial_578_447482)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6918 45.8006C45.4965 46.002 45.3074 46.216 45.1309 46.4362L44.8424 46.8259C45.1614 47.2934 45.5325 47.7144 45.9501 48.0891C46.2211 48.3282 46.5047 48.5484 46.8073 48.7498C47.0089 48.6176 47.198 48.4792 47.3808 48.3282C47.5762 48.1772 47.7527 48.0135 47.9291 47.8374C48.0048 47.7618 48.0804 47.6863 48.1497 47.6108C48.1626 47.6022 48.1726 47.5907 48.1817 47.5802C48.1859 47.5754 48.1899 47.5708 48.1938 47.5668C48.4073 47.33 48.6039 47.0822 48.7839 46.8231C48.5321 46.4547 48.2454 46.1099 47.9293 45.7944C47.7654 45.6307 47.5953 45.4734 47.4125 45.3224C47.2234 45.1651 47.0217 45.0204 46.8137 44.8819C46.5364 45.0707 46.2717 45.2721 46.0196 45.4923C45.9061 45.593 45.799 45.6937 45.6918 45.8006ZM48.8173 46.7747C48.5584 46.3866 48.2586 46.0225 47.9293 45.6937C47.7654 45.5301 47.589 45.3728 47.4125 45.2217C47.2234 45.0644 47.0217 44.9134 46.8137 44.7812C46.5364 44.9637 46.2717 45.1714 46.0196 45.3916C45.9061 45.4923 45.799 45.593 45.6918 45.7C45.4902 45.9013 45.3011 46.109 45.1309 46.3355C45.0162 46.4787 44.9119 46.6271 44.8086 46.7759C44.8067 46.7732 44.8049 46.7704 44.803 46.7676C44.7992 46.7732 44.7955 46.7783 44.7919 46.7832C44.7834 46.7946 44.7759 46.8047 44.7715 46.818C44.7752 46.8236 44.779 46.8287 44.7826 46.8335C44.7911 46.8449 44.7986 46.8551 44.803 46.8683C45.1307 47.3528 45.5152 47.7933 45.9501 48.1897C46.2148 48.4289 46.5047 48.6554 46.8073 48.8505C47.0026 48.7183 47.198 48.5799 47.3808 48.4289C47.5699 48.2715 47.7527 48.1079 47.9291 47.938C47.9669 47.9003 48.0032 47.8625 48.0394 47.8248C48.0757 47.787 48.1119 47.7493 48.1497 47.7115C48.1537 47.7075 48.1577 47.7029 48.1619 47.6981C48.1709 47.6876 48.1809 47.6761 48.1938 47.6675C48.4333 47.4032 48.6476 47.12 48.8493 46.8242C48.8471 46.8209 48.8448 46.8177 48.8426 46.8147C48.8428 46.8144 48.843 46.8141 48.8432 46.8138C48.8352 46.8016 48.8271 46.7894 48.819 46.7772C48.8186 46.7761 48.8182 46.775 48.8178 46.7739C48.8176 46.7742 48.8175 46.7744 48.8173 46.7747Z",
    fill: "url(#paint190_radial_578_447482)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8135 45.4921C46.8135 45.4921 47.6076 45.9892 48.1559 46.8324C48.1559 46.8261 47.7652 45.9577 46.8135 45.4921Z",
    fill: "url(#paint191_radial_578_447482)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4775 46.8274C45.4775 46.8274 45.9502 47.658 46.7507 48.1551L46.8137 48.7592L46.8578 48.1425C46.8578 48.1425 47.4566 47.8908 48.1562 46.8274C48.1562 46.8274 47.2738 48.0104 46.8011 48.0733C46.8011 48.0796 46.2528 47.8657 45.4775 46.8274Z",
    fill: "url(#paint192_radial_578_447482)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8193 48.1613C46.8193 48.1613 47.6513 47.6893 48.1492 46.8902L48.7543 46.8273L48.1366 46.7832C48.1366 46.7832 47.8845 46.1854 46.8193 45.4869C46.8193 45.4869 48.0042 46.3679 48.0673 46.8398C48.0736 46.8398 47.8593 47.3873 46.8193 48.1613Z",
    fill: "url(#paint193_radial_578_447482)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7884 45.4869C46.7884 45.4869 45.9565 45.9589 45.4586 46.758L44.8535 46.821L45.4712 46.865C45.4712 46.865 45.7233 47.4628 46.7884 48.1613C46.7884 48.1613 45.6035 47.2803 45.5405 46.8084C45.5342 46.8084 45.7485 46.2609 46.7884 45.4869Z",
    fill: "url(#paint194_radial_578_447482)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1562 46.82C48.1562 46.82 47.6835 45.9894 46.883 45.4923L46.82 44.8882L46.7759 45.5049C46.7759 45.5049 46.1771 45.7566 45.4775 46.82C45.4775 46.82 46.3599 45.637 46.8326 45.5741C46.8326 45.5678 47.381 45.7817 48.1562 46.82Z",
    fill: "url(#paint195_radial_578_447482)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6895 15.4111V28.7265C33.6895 29.3839 34.036 29.9935 34.5978 30.3401L45.6183 36.9381C46.216 37.2967 46.9571 37.2967 47.5427 36.9381L58.5632 30.3401C59.125 30.0055 59.4716 29.3959 59.4716 28.7265V15.4111C59.4716 14.7537 59.125 14.1441 58.5632 13.7975L47.5427 7.19948C46.9451 6.8409 46.204 6.8409 45.6183 7.19948L34.5978 13.7975C34.036 14.156 33.6895 14.7656 33.6895 15.4111Z",
    fill: "url(#paint196_radial_578_447482)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4951 14.5263V27.8895C59.4951 28.3557 59.2441 28.798 58.8377 29.0251L47.2674 35.7067C46.861 35.9457 46.359 35.9457 45.9406 35.7067L34.3703 29.0251C33.9639 28.786 33.7129 28.3557 33.7129 27.8895V14.5263C33.7129 14.0602 33.9639 13.6179 34.3703 13.3908L45.9406 6.7092C46.347 6.47014 46.849 6.47014 47.2674 6.7092L58.8377 13.3908C59.2322 13.6179 59.4951 14.0602 59.4951 14.5263Z",
    fill: "url(#paint197_radial_578_447482)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M58.826 13.3787L47.2557 6.69711C46.8493 6.45806 46.3473 6.45806 45.9289 6.69711L34.3586 13.3787C33.9522 13.6178 33.7012 14.0481 33.7012 14.5262V15.0521C33.7012 14.586 33.9522 14.1437 34.3586 13.9046L45.9289 7.22303C46.3353 6.98397 46.8374 6.98397 47.2557 7.22303L58.826 13.9046C59.2324 14.1437 59.4834 14.574 59.4834 15.0521V14.5262C59.4953 14.06 59.2324 13.6178 58.826 13.3787Z",
    fill: "url(#paint198_radial_578_447482)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M58.826 28.9532L47.2557 35.6349C46.8493 35.8739 46.3473 35.8739 45.9289 35.6349L34.3586 28.9532C33.9522 28.7142 33.7012 28.2839 33.7012 27.8058V27.8894C33.7012 28.3556 33.9522 28.7978 34.3586 29.0369L45.9289 35.7185C46.3353 35.9576 46.8374 35.9576 47.2557 35.7185L58.826 29.0369C59.2324 28.7978 59.4834 28.3675 59.4834 27.8894V27.8058C59.4953 28.2839 59.2324 28.7142 58.826 28.9532Z",
    fill: "url(#paint199_radial_578_447482)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4836 16.355H33.6895V21.925H59.4836V16.355Z",
    fill: "url(#paint200_radial_578_447482)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4836 21.9133H33.6895V27.4834H59.4836V21.9133Z",
    fill: "url(#paint201_radial_578_447482)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8262 13.3787L47.2559 6.69711C46.8495 6.45806 46.3475 6.45806 45.9291 6.69711L34.3588 13.3787C34.3349 13.3907 34.311 13.4026 34.2871 13.4265L45.4032 7.0079C45.8096 6.76884 46.3116 6.76884 46.7299 7.0079L58.3003 13.6895C58.7067 13.9286 58.9577 14.3589 58.9577 14.825V28.1882C58.9577 28.6305 58.7425 29.0489 58.3601 29.2879L58.8142 29.0249C59.2206 28.7859 59.4716 28.3556 59.4716 27.8894V14.5262C59.4955 14.06 59.2326 13.6178 58.8262 13.3787Z",
    fill: "url(#paint202_radial_578_447482)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8262 28.9535L47.2559 35.6351C46.8495 35.8742 46.3475 35.8742 45.9291 35.6351L34.3588 28.9535C34.0958 28.7981 33.8926 28.5591 33.7851 28.2841V15.3392C33.7851 14.8492 33.9763 14.4069 34.2871 14.0603C33.9166 14.4189 33.6895 14.909 33.6895 15.4349V27.8179V27.9016V28.7383C33.6895 29.3957 34.036 30.0053 34.5978 30.352L45.6183 36.9499C46.216 37.3085 46.9571 37.3085 47.5427 36.9499L58.5632 30.352C58.7186 30.2683 58.8501 30.1487 58.9696 30.0292C58.874 30.1129 58.7664 30.1966 58.6469 30.2683L47.6264 36.8662C47.0287 37.2248 46.2877 37.2248 45.702 36.8662L34.6815 30.2683C34.1197 29.9336 33.7731 29.324 33.7731 28.6546V28.3678C33.8807 28.6546 34.0839 28.8937 34.3469 29.0372L45.9172 35.7188C46.3235 35.9578 46.8256 35.9578 47.2439 35.7188L58.8142 29.0372C59.2206 28.7981 59.4716 28.3678 59.4716 27.8897V27.806C59.4955 28.2841 59.2326 28.7144 58.8262 28.9535Z",
    fill: "url(#paint203_radial_578_447482)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3545 16.3073V26.9931C36.3545 27.3517 36.5458 27.6864 36.8565 27.8538L46.108 33.1966C46.4188 33.3759 46.8012 33.3759 47.112 33.1966L56.3635 27.8538C56.6743 27.6745 56.8655 27.3398 56.8655 26.9931V16.3073C56.8655 15.9487 56.6743 15.614 56.3635 15.4467L47.112 10.1038C46.8012 9.92454 46.4188 9.92454 46.108 10.1038L36.8565 15.4467C36.5338 15.614 36.3545 15.9487 36.3545 16.3073Z",
    fill: "url(#paint204_linear_578_447482)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8809 16.5819V26.706C36.8809 27.0407 37.0602 27.3634 37.359 27.5307L46.1204 32.5868C46.4073 32.7541 46.7778 32.7541 47.0647 32.5868L55.8261 27.5307C56.1129 27.3634 56.3042 27.0407 56.3042 26.706V16.5819C56.3042 16.2473 56.1249 15.9245 55.8261 15.7572L47.0647 10.7012C46.7778 10.5338 46.4073 10.5338 46.1204 10.7012L37.359 15.7572C37.0721 15.9365 36.8809 16.2473 36.8809 16.5819Z",
    fill: "url(#paint205_radial_578_447482)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8809 16.5819V26.706C36.8809 27.0407 37.0602 27.3634 37.359 27.5307L46.1204 32.5868C46.4073 32.7541 46.7778 32.7541 47.0647 32.5868L55.8261 27.5307C56.1129 27.3634 56.3042 27.0407 56.3042 26.706V16.5819C56.3042 16.2473 56.1249 15.9245 55.8261 15.7572L47.0647 10.7012C46.7778 10.5338 46.4073 10.5338 46.1204 10.7012L37.359 15.7572C37.0721 15.9365 36.8809 16.2473 36.8809 16.5819Z",
    fill: "url(#paint206_radial_578_447482)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3906 16.2833C36.3906 15.9247 36.5819 15.5901 36.8927 15.4227L46.1441 10.0798C46.4549 9.90051 46.8374 9.90051 47.1482 10.0798L56.3997 15.4227C56.7104 15.602 56.9017 15.9367 56.9017 16.2833V16.1519C56.9017 15.7933 56.7104 15.4586 56.3997 15.2912L47.1482 9.94831C46.8374 9.76902 46.4549 9.76902 46.1441 9.94831L36.8927 15.2912C36.5819 15.4705 36.3906 15.8052 36.3906 16.1519V26.8377V16.2833Z",
    fill: "url(#paint207_radial_578_447482)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3518 27.6983L47.1003 33.0413C46.7895 33.2206 46.407 33.2206 46.0963 33.0413L36.8448 27.6983C36.534 27.519 36.3428 27.1844 36.3428 26.8378V26.9931C36.3428 27.3517 36.534 27.6864 36.8448 27.8538L46.0963 33.1966C46.407 33.3759 46.7895 33.3759 47.1003 33.1966L56.3518 27.8538C56.6625 27.6745 56.8538 27.3398 56.8538 26.9931V26.8378C56.8538 27.1844 56.6625 27.519 56.3518 27.6983Z",
    fill: "url(#paint208_radial_578_447482)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8378 15.7572L47.0764 10.7012C46.7895 10.5338 46.4189 10.5338 46.1321 10.7012L37.3707 15.7572C37.0838 15.9245 36.8926 16.2473 36.8926 16.5819V26.706C36.8926 27.0407 37.0719 27.3634 37.3707 27.5307L46.1321 32.5868C46.4189 32.7541 46.7895 32.7541 47.0764 32.5868L55.8378 27.5307C56.1246 27.3634 56.3159 27.0407 56.3159 26.706V16.5819C56.3159 16.2473 56.1366 15.9365 55.8378 15.7572ZM55.8617 26.4669C55.8617 26.7897 55.6943 27.0885 55.4075 27.2558L47.0525 32.0848C46.7656 32.2401 46.4309 32.2401 46.156 32.0848L37.801 27.2558C37.5141 27.1004 37.3468 26.8016 37.3468 26.4669V16.821C37.3468 16.4983 37.5141 16.1995 37.801 16.0322L46.156 11.2032C46.4429 11.0478 46.7775 11.0478 47.0525 11.2032L55.4075 16.0322C55.6943 16.1875 55.8617 16.4863 55.8617 16.821V26.4669Z",
    fill: "url(#paint209_linear_578_447482)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4743 27.1007V16.4149C36.4743 16.0563 36.6655 15.7217 36.9763 15.5543L46.2278 10.2114C46.5385 10.0321 46.921 10.0321 47.2318 10.2114L56.4833 15.5543C56.5072 15.5663 56.543 15.5902 56.5669 15.6021C56.5072 15.5424 56.4354 15.4826 56.3518 15.4467L47.1003 10.1038C46.7895 9.92454 46.4071 9.92454 46.0963 10.1038L36.8448 15.4467C36.534 15.626 36.3428 15.9607 36.3428 16.3073V26.9931C36.3428 27.3159 36.4982 27.6147 36.7611 27.806C36.5818 27.6147 36.4743 27.3637 36.4743 27.1007Z",
    fill: "url(#paint210_radial_578_447482)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9771 13.0682L38.8413 18.2557C38.5066 18.4948 38.3632 18.9251 38.4947 19.3196L41.2199 27.7104C41.3395 28.1048 41.71 28.3678 42.1283 28.3678H50.9495C51.3679 28.3678 51.7265 28.1048 51.8579 27.7104L54.5832 19.3196C54.7027 18.9251 54.5712 18.4948 54.2365 18.2557L47.1007 13.0682C46.766 12.8292 46.3118 12.8292 45.9771 13.0682Z",
    fill: "url(#paint211_radial_578_447482)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M54.364 17.9562L47.2281 12.7686C46.8935 12.5296 46.4393 12.5296 46.1046 12.7686L38.9687 17.9562C38.8373 18.0518 38.7416 18.1714 38.6699 18.3148C38.7177 18.2431 38.7895 18.1833 38.8612 18.1235L45.997 12.936C46.3317 12.697 46.7859 12.697 47.1206 12.936L54.2564 18.1235C54.5911 18.3626 54.7345 18.7929 54.603 19.1873L51.8778 27.5782C51.8658 27.626 51.8539 27.6619 51.83 27.6978C51.9017 27.6141 51.9495 27.5065 51.9854 27.4108L54.7106 19.02C54.8421 18.6256 54.6987 18.2072 54.364 17.9562Z",
    fill: "url(#paint212_radial_578_447482)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0611 12.9725L38.9253 18.16C38.5906 18.3991 38.4472 18.8294 38.5786 19.2238L41.3039 27.6147C41.4234 28.0091 41.7939 28.2721 42.2123 28.2721H51.0334C51.4518 28.2721 51.8104 28.0091 51.9419 27.6147L54.6671 19.2238C54.7867 18.8294 54.6551 18.3991 54.3205 18.16L47.1847 12.9725C46.85 12.7334 46.3958 12.7334 46.0611 12.9725Z",
    fill: "url(#paint213_radial_578_447482)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0728 13.1994L39.1282 18.2435C38.8055 18.4826 38.674 18.9009 38.7935 19.2714L41.4471 27.4352C41.5666 27.8177 41.9252 28.0807 42.3316 28.0807H50.9137C51.3081 28.0807 51.6787 27.8297 51.7982 27.4352L54.4517 19.2714C54.5712 18.8889 54.4398 18.4706 54.117 18.2435L47.1725 13.1994C46.8378 12.9604 46.3955 12.9604 46.0728 13.1994Z",
    fill: "url(#paint214_radial_578_447482)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8413 19.4149C38.9011 19.2715 39.0087 19.1639 39.1282 19.0563L46.0728 14.0122C46.3955 13.7731 46.8378 13.7731 47.1605 14.0122L54.1051 19.0563C54.2366 19.1519 54.3322 19.2715 54.3919 19.4149L54.4397 19.2714C54.5593 18.8889 54.4278 18.4706 54.1051 18.2435L47.1605 13.1994C46.8378 12.9604 46.3955 12.9604 46.0728 13.1994L39.1282 18.2435C38.8055 18.4826 38.674 18.9009 38.7935 19.2714L38.8413 19.4149Z",
    fill: "url(#paint215_radial_578_447482)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1053 18.2435L53.8185 18.0403C53.8304 18.1718 53.8304 18.3032 53.7945 18.4347L51.3442 26.6702C51.2247 27.0527 50.89 27.3037 50.4956 27.3037H42.7262C42.3318 27.3037 41.9852 27.0527 41.8776 26.6702L39.4273 18.4347C39.3914 18.3032 39.3795 18.1718 39.4034 18.0403L39.1165 18.2435C38.7938 18.4826 38.6623 18.9009 38.7818 19.2714L41.4354 27.4352C41.5549 27.8177 41.9135 28.0806 42.3199 28.0806H50.902C51.2964 28.0806 51.667 27.8296 51.7865 27.4352L54.44 19.2714C54.5715 18.9009 54.44 18.4826 54.1053 18.2435Z",
    fill: "url(#paint216_radial_578_447482)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5909 27.292H42.8096C42.451 27.292 42.1163 27.053 42.0087 26.7063L39.6063 19.3076C39.5226 19.0805 39.5584 18.8294 39.6779 18.6262C39.4986 18.8414 39.4389 19.1402 39.5226 19.4271L41.9251 26.8259C42.0446 27.1725 42.3554 27.4115 42.7259 27.4115H50.5072C50.806 27.4115 51.0929 27.2442 51.2363 26.9932C51.0809 27.1725 50.8539 27.292 50.5909 27.292Z",
    fill: "url(#paint217_radial_578_447482)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3287 18.447L47.0774 13.9049C46.7905 13.6897 46.3841 13.6897 46.0972 13.9049L39.8459 18.447C39.6906 18.5545 39.5949 18.7099 39.5352 18.8773C39.5949 18.7577 39.6786 18.6621 39.7862 18.5785L46.0375 14.0364C46.3243 13.8212 46.7308 13.8212 47.0176 14.0364L53.2689 18.5785C53.5558 18.7936 53.6873 19.1761 53.5677 19.5107L51.1772 26.8379C51.1891 26.802 51.213 26.7661 51.225 26.7183L53.6155 19.3674C53.7351 19.0327 53.6275 18.6621 53.3287 18.447Z",
    fill: "url(#paint218_radial_578_447482)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1007 14.1437C46.8138 13.9285 46.4313 13.9285 46.1325 14.1437L40.0127 18.5901C39.7258 18.8053 39.6063 19.1638 39.7139 19.5105L41.3394 24.5068C44.2679 22.0206 47.9613 18.8889 50.6029 16.7016L47.1007 14.1437Z",
    fill: "url(#paint219_radial_578_447482)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0195 18.266C43.348 18.2786 43.626 18.3039 43.8661 18.3165C44.0935 18.3292 44.283 18.3292 44.422 18.3292C44.5863 18.3292 44.9274 18.3165 45.4328 18.2912C45.6224 18.2786 45.774 18.2786 45.8624 18.2786V18.6829C45.5844 18.6956 45.3949 18.7335 45.3065 18.7714C45.218 18.8093 45.1801 18.8977 45.1801 19.0241C45.1801 19.0746 45.1928 19.1505 45.2054 19.2263C45.218 19.3021 45.2559 19.3905 45.2938 19.4916L46.8859 24.0023L48.3894 19.5042C48.44 19.3905 48.4652 19.302 48.4779 19.2515C48.4905 19.201 48.4905 19.1252 48.4905 19.062C48.4905 18.923 48.44 18.8219 48.3263 18.7587C48.2125 18.6956 48.023 18.6703 47.7577 18.6703V18.266C48.0104 18.2786 48.1999 18.2912 48.3642 18.3039C48.5284 18.3165 48.6548 18.3165 48.7685 18.3165C48.8569 18.3165 48.9706 18.3165 49.1096 18.3039C49.2486 18.2912 49.4508 18.2913 49.7035 18.266V18.6703C49.4634 18.6829 49.2992 18.7335 49.2107 18.7966C49.1223 18.8598 49.0465 18.9609 49.0086 19.1125L47.3786 23.8001C47.2775 24.0781 47.1765 24.3687 47.0628 24.6719C46.949 24.9752 46.8353 25.2911 46.709 25.607L46.2036 25.5564L43.8534 19.3273L43.8408 19.2894C43.6892 18.8725 43.4239 18.6703 43.0448 18.6703L43.0195 18.266Z",
    fill: "url(#paint220_radial_578_447482)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0195 18.266C43.348 18.2786 43.626 18.3039 43.8661 18.3165C44.0935 18.3292 44.283 18.3292 44.422 18.3292C44.5863 18.3292 44.9274 18.3165 45.4328 18.2912C45.6224 18.2786 45.774 18.2786 45.8624 18.2786V18.6829C45.5844 18.6956 45.3949 18.7335 45.3065 18.7714C45.218 18.8093 45.1801 18.8977 45.1801 19.0241C45.1801 19.0746 45.1928 19.1505 45.2054 19.2263C45.218 19.3021 45.2559 19.3905 45.2938 19.4916L46.8859 24.0023L48.3894 19.5042C48.44 19.3905 48.4652 19.302 48.4779 19.2515C48.4905 19.201 48.4905 19.1252 48.4905 19.062C48.4905 18.923 48.44 18.8219 48.3263 18.7587C48.2125 18.6956 48.023 18.6703 47.7577 18.6703V18.266C48.0104 18.2786 48.1999 18.2912 48.3642 18.3039C48.5284 18.3165 48.6548 18.3165 48.7685 18.3165C48.8569 18.3165 48.9706 18.3165 49.1096 18.3039C49.2486 18.2912 49.4508 18.2913 49.7035 18.266V18.6703C49.4634 18.6829 49.2992 18.7335 49.2107 18.7966C49.1223 18.8598 49.0465 18.9609 49.0086 19.1125L47.3786 23.8001C47.2775 24.0781 47.1765 24.3687 47.0628 24.6719C46.949 24.9752 46.8353 25.2911 46.709 25.607L46.2036 25.5564L43.8534 19.3273L43.8408 19.2894C43.6892 18.8725 43.4239 18.6703 43.0448 18.6703L43.0195 18.266Z",
    fill: "url(#paint221_radial_578_447482)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8477 18.266C43.1762 18.2786 43.4541 18.3039 43.6942 18.3165C43.9216 18.3292 44.1112 18.3292 44.2501 18.3292C44.4144 18.3292 44.7555 18.3165 45.2609 18.2912C45.4505 18.2786 45.6021 18.2786 45.6905 18.2786V18.6829C45.4126 18.6956 45.223 18.7335 45.1346 18.7714C45.0462 18.8093 45.0082 18.8977 45.0082 19.0241C45.0082 19.0746 45.0209 19.1505 45.0335 19.2263C45.0462 19.3021 45.0841 19.3905 45.122 19.4916L46.714 24.0023L48.2176 19.5042C48.2681 19.3905 48.2934 19.302 48.306 19.2515C48.3186 19.201 48.3186 19.1252 48.3186 19.062C48.3186 18.923 48.2681 18.8219 48.1544 18.7587C48.0407 18.6956 47.8511 18.6703 47.5858 18.6703V18.266C47.8385 18.2786 48.028 18.2912 48.1923 18.3039C48.3565 18.3165 48.4829 18.3165 48.5966 18.3165C48.6851 18.3165 48.7988 18.3165 48.9378 18.3039C49.0767 18.2912 49.2789 18.2913 49.5316 18.266V18.6703C49.2915 18.6829 49.1273 18.7335 49.0388 18.7966C48.9504 18.8598 48.8746 18.9609 48.8367 19.1125L47.2068 23.8001C47.1057 24.0781 47.0046 24.3687 46.8909 24.6719C46.7772 24.9752 46.6634 25.2911 46.5371 25.607L46.0317 25.5564L43.6816 19.3273L43.6689 19.2894C43.5173 18.8725 43.252 18.6703 42.8729 18.6703L42.8477 18.266Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0068 18.266C43.3353 18.2786 43.6133 18.3039 43.8534 18.3165C44.0808 18.3292 44.2703 18.3292 44.4093 18.3292C44.5736 18.3292 44.9147 18.3165 45.4201 18.2912C45.6097 18.2786 45.7613 18.2786 45.8497 18.2786V18.6829C45.5718 18.6956 45.3822 18.7335 45.2938 18.7714C45.2053 18.8093 45.1674 18.8977 45.1674 19.0241C45.1674 19.0746 45.1801 19.1505 45.1927 19.2263C45.2053 19.3021 45.2432 19.3905 45.2811 19.4916L46.8732 24.0023L48.3767 19.5042C48.4273 19.3905 48.4525 19.302 48.4652 19.2515C48.4778 19.201 48.4778 19.1252 48.4778 19.062C48.4778 18.923 48.4273 18.8219 48.3136 18.7587C48.1998 18.6956 48.0103 18.6703 47.745 18.6703V18.266C47.9977 18.2786 48.1872 18.2912 48.3515 18.3039C48.5157 18.3165 48.6421 18.3165 48.7558 18.3165C48.8442 18.3165 48.958 18.3165 49.0969 18.3039C49.2359 18.2912 49.4381 18.2913 49.6908 18.266V18.6703C49.4507 18.6829 49.2865 18.7335 49.198 18.7966C49.1096 18.8598 49.0338 18.9609 48.9959 19.1125L47.3659 23.8001C47.2649 24.0781 47.1638 24.3687 47.0501 24.6719C46.9363 24.9752 46.8226 25.2911 46.6963 25.607L46.1909 25.5564L43.8407 19.3273L43.8281 19.2894C43.6765 18.8725 43.4112 18.6703 43.0321 18.6703L43.0068 18.266Z",
    fill: "url(#paint222_radial_578_447482)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7725 23.6989L45.2815 19.4788C45.2436 19.3777 45.2183 19.2767 45.1931 19.2135C45.1678 19.1503 45.1678 19.0745 45.1678 19.0113C45.1678 18.9355 45.1804 18.8723 45.2183 18.8218C45.1425 18.8344 45.092 18.847 45.0541 18.8723C44.9656 18.9228 44.9277 18.9987 44.9277 19.125C44.9277 19.1755 44.9404 19.2514 44.953 19.3272C44.9656 19.403 45.0035 19.4914 45.0415 19.5925L46.6335 24.1032L46.7725 23.6989Z",
    fill: "url(#paint223_radial_578_447482)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6133 18.4297C43.8407 18.4424 44.0303 18.4424 44.1693 18.4424C44.3335 18.4424 44.6747 18.4298 45.1801 18.4045C45.3696 18.3919 45.5212 18.3919 45.6097 18.3919V18.6951C45.6855 18.6824 45.7613 18.6824 45.8497 18.6824V18.2782C45.7486 18.2782 45.6097 18.2907 45.4201 18.2907C44.9147 18.316 44.5736 18.3287 44.4093 18.3287C44.283 18.3287 44.0934 18.316 43.8534 18.316C43.6259 18.3034 43.3353 18.2908 43.0068 18.2655V18.4045C43.2469 18.4171 43.4491 18.4171 43.6133 18.4297Z",
    fill: "url(#paint224_radial_578_447482)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0971 18.3038C48.9581 18.3164 48.8444 18.3164 48.7559 18.3164C48.6422 18.3164 48.5159 18.3164 48.3516 18.3038C48.1873 18.2911 47.9978 18.2912 47.7451 18.2659V18.4049C47.8841 18.4175 48.0104 18.4175 48.1115 18.4175C48.2758 18.4301 48.4021 18.4301 48.5159 18.4301C48.6043 18.4301 48.718 18.4301 48.857 18.4175C48.996 18.4048 49.1981 18.4049 49.4509 18.3796V18.6828C49.5267 18.6702 49.6025 18.6576 49.6909 18.6449V18.2406C49.4382 18.2785 49.236 18.2911 49.0971 18.3038Z",
    fill: "url(#paint225_radial_578_447482)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9453 18.9099C48.8569 18.9605 48.7811 19.0742 48.7432 19.2258L47.1133 23.9134C47.0122 24.1913 46.9111 24.482 46.7974 24.7852C46.7089 25.0379 46.5952 25.3032 46.4941 25.5812L46.6837 25.5939C46.81 25.278 46.9237 24.9621 47.0374 24.6589C47.1512 24.3556 47.2522 24.065 47.3533 23.787L48.9832 19.0995C49.0212 18.9857 49.0717 18.8973 49.1349 18.8341C49.0591 18.8467 48.9959 18.872 48.9453 18.9099Z",
    fill: "url(#paint226_radial_578_447482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7144 14.4506) scale(30.0801 13.9161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7113 14.452) scale(30.0801 13.9161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6947 14.452) scale(30.0801 13.9161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2488 13.9259) scale(35.136 16.5488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2188 13.4765) scale(19.048 21.4179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8463 13.3753) scale(13.0373 22.0484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.223 13.2111) scale(50.2974 21.1809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_578_447482",
    x1: 30.0057,
    y1: 38.4377,
    x2: 63.8899,
    y2: 39.1743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266149,
    stopColor: "#E6EBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487202,
    stopColor: "#4FA590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772255,
    stopColor: "#6F8480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_578_447482",
    x1: 30.4968,
    y1: 34.7546,
    x2: 62.6623,
    y2: 34.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32508,
    stopColor: "#ECFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#EEF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537957,
    stopColor: "#7F9195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762905,
    stopColor: "#94A8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAB7B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.457 29.8439) rotate(-0.998085) scale(35.24 15.8184)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132846,
    stopColor: "#01181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#6D7879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690204,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5797 51.6641) rotate(-92.7263) scale(15.4864 27.0304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3DCCE",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5602 33.2865) scale(12.0476 12.0476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#CECECE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4789 33.324) rotate(180) scale(12.0477 12.0477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#CECECE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7089 28.5075) rotate(90) scale(14.987 19.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5848 27.3776) scale(11.0807 11.0807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3823 31.1181) scale(12.3306 12.3307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4315 28.802) scale(4.52477 4.52477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.2908 32.1651) scale(3.25676 3.25689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0227 23.8867) scale(14.4594 14.4595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000182901,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0974 29.0693) rotate(180) scale(7.32358 7.32359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6907 30.1627) scale(0.0190553 0.00933298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4768 30.0707) scale(9.28431 9.28413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.9809 26.6919) rotate(178.409) scale(7.45158 2.08986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.681 27.4005) scale(10.5185 10.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5269 24.2473) scale(10.3982 10.3982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0187 27.3774) rotate(180) scale(11.0807 11.0807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2207 31.1181) rotate(180) scale(12.3307 12.3307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1719 28.8018) rotate(180) scale(4.52477 4.52477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.313 32.1649) rotate(180) scale(3.25695 3.25689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5803 23.8865) rotate(180) scale(14.4595 14.4595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000182901,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#4B5959"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.506 29.069) scale(7.32358 7.32359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.91 30.1626) rotate(180) scale(0.0190553 0.00933298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1262 30.0705) rotate(180) scale(9.28434 9.28413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6614 26.6872) rotate(1.59137) scale(7.45153 2.08986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1271 27.9317) rotate(180) scale(10.8037 10.8038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0765 24.2471) rotate(180) scale(10.3982 10.3982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_578_447482",
    x1: 38.3623,
    y1: 16.4063,
    x2: 35.1758,
    y2: 10.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548834,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744493,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1226 9.42079) rotate(-27.8822) scale(12.3336 12.3414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4794 12.3837) rotate(-27.8822) scale(4.52587 4.52871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8999 9.94038) rotate(-27.8822) scale(3.25755 3.25973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7199 14.1186) rotate(-27.8822) scale(14.4629 14.4721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0592 12.3034) rotate(152.118) scale(7.32536 7.32996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8837 14.3324) rotate(-27.8822) scale(0.0190553 0.00933297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.464 9.36827) rotate(-27.8822) scale(9.28657 9.29221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1838 14.9296) rotate(153.71) scale(7.45321 2.09173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_578_447482",
    x1: 37.8712,
    y1: 14.933,
    x2: 35.4192,
    y2: 11.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1855 10.2894) rotate(-27.8822) scale(10.4007 10.4073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_578_447482",
    x1: 54.8125,
    y1: 16.4063,
    x2: 57.999,
    y2: 10.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548834,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744493,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#DCDADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0522 9.42079) rotate(-152.118) scale(12.3336 12.3414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6954 12.3837) rotate(-152.118) scale(4.52587 4.52871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2749 9.94038) rotate(-152.118) scale(3.25755 3.25973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4549 14.1186) rotate(-152.118) scale(14.4629 14.4721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1156 12.3034) rotate(27.8822) scale(7.32536 7.32996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2901 14.3324) rotate(-152.118) scale(0.0190553 0.00933297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7108 9.36827) rotate(-152.118) scale(9.28657 9.29221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.991 14.9296) rotate(26.2898) scale(7.45321 2.09173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_578_447482",
    x1: 55.3037,
    y1: 14.933,
    x2: 57.7556,
    y2: 11.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9893 10.2894) rotate(-152.118) scale(10.4007 10.4073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.4651 21.9162) rotate(-11.5669) scale(15.5208 15.5208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.4035 15.2402) rotate(-11.5669) scale(31.3847 31.3848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.3532 16.3232) rotate(-11.5669) scale(19.6796 19.6796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.961 10.9301) rotate(-11.5668) scale(18.039 18.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6406 25.1194) rotate(-11.567) scale(7.96078 7.96087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.7114 22.8006) rotate(-11.5668) scale(4.80906 4.80905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.4568 20.4521) rotate(-11.5668) scale(8.00962 8.00961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.8709 21.6735) rotate(-11.5668) scale(11.4908 11.4908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5442 12.8689) rotate(-11.5668) scale(20.8591 20.859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_578_447482",
    x1: 61.6424,
    y1: 19.1827,
    x2: 62.9013,
    y2: 25.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3278 15.6224) rotate(-11.5669) scale(11.9248 11.9248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.8957 15.52) scale(13.5881 21.0082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.7586 17.5128) rotate(-21.9036) scale(16.7253 16.7253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#4B5959"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.7631 9.28713) rotate(-21.9036) scale(33.8205 33.8205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.739 11.025) rotate(-21.9036) scale(21.2069 21.2069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.0018 3.06325) rotate(-21.9036) scale(19.439 19.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2633 21.8413) rotate(-21.9036) scale(8.57866 8.57866)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.4308 17.6291) rotate(-21.9034) scale(5.18226 5.18223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.6368 8.40775) scale(14.0526 14.0526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0204 17.5633) rotate(-21.9036) scale(12.3826 12.3826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.2124 7.5196) rotate(-21.9037) scale(22.478 22.4781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_578_447482",
    x1: 58.2441,
    y1: 15.1577,
    x2: 60.768,
    y2: 21.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6356 10.0934) rotate(-21.9035) scale(12.8503 12.8502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1653 21.3209) rotate(-22.7215) scale(21.2957 45.5092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5021 21.869) rotate(-168.433) scale(15.5207 15.5208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5641 15.1931) rotate(-168.433) scale(31.3847 31.3848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6143 16.2761) rotate(-168.433) scale(19.6796 19.6796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0062 10.8829) rotate(-168.433) scale(18.039 18.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3262 25.0722) rotate(-168.433) scale(7.96082 7.96087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2563 22.7534) rotate(-168.433) scale(4.80902 4.80904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5109 20.4049) rotate(-168.433) scale(8.00959 8.00961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0976 21.6263) rotate(-168.433) scale(11.4908 11.4908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4237 12.8217) rotate(-168.433) scale(20.8591 20.859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_578_447482",
    x1: 31.333,
    y1: 19.137,
    x2: 30.0741,
    y2: 25.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.64 15.5752) rotate(-168.433) scale(11.9248 11.9248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8966 15.52) scale(13.5881 21.0082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3489 17.6136) rotate(-158.096) scale(16.7253 16.7253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#4B5959"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3444 9.38797) rotate(-158.096) scale(33.8205 33.8204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3686 11.1259) rotate(-158.096) scale(21.2069 21.2069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1065 3.16396) rotate(-158.096) scale(19.439 19.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8448 21.942) rotate(-158.096) scale(8.57866 8.57866)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6776 17.7298) rotate(-158.097) scale(5.18226 5.18223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3469 8.40775) rotate(180) scale(14.0526 14.0526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0871 17.664) rotate(-158.096) scale(12.3826 12.3826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8949 7.62031) rotate(-158.096) scale(22.478 22.4781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_578_447482",
    x1: 34.8641,
    y1: 15.2589,
    x2: 32.3401,
    y2: 21.5363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4714 10.1941) rotate(-158.096) scale(12.8503 12.8502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8281 10.7615) scale(13.9333 29.7756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5784 38.5617) scale(6.13608 6.12626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0D8B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.909 41.9962) scale(3.14481 3.13978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#005847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005B49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.566 38.7704) scale(3.06805 3.06313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C19A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6223 40.1549) scale(4.13747 4.13084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA9C",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9933 42.6181) scale(2.49254 2.48855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8697 39.8991) scale(2.85969 2.85511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FABF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3206 40.0538) scale(4.27605 4.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00FCC9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3081 44.2676) scale(4.37667 4.36966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.19 38.7411) scale(2.63233 2.62812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6176 40.2541) scale(5.94785 5.93832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#74FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6065 38.7666) scale(3.86884 3.86264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFBDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6079 43.1079) scale(3.42901 3.42352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E9D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6079 43.1077) scale(3.42901 3.42362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5628 40.1155) scale(2.72305 2.71869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5349 42.1125) scale(2.36834 2.36454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6977 41.0579) rotate(-90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4559 40.9507) rotate(90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FCE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6422 39.8953) rotate(180) scale(2.36834 2.36455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68F1D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7161 41.8029) scale(6.13608 6.12626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0D8B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0466 45.2374) scale(3.14481 3.13978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#005847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005B49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7037 42.0116) scale(3.06805 3.06313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C19A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.76 43.3961) scale(4.13747 4.13084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA9C",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.131 45.8593) scale(2.49254 2.48855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0074 43.1403) scale(2.85969 2.85511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FABF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4583 43.295) scale(4.27605 4.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00FCC9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4458 47.5088) scale(4.37667 4.36966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3276 41.9823) scale(2.63233 2.62812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7553 43.4953) scale(5.94785 5.93832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#74FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7442 42.0078) scale(3.86884 3.86264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFBDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7456 46.3491) scale(3.42901 3.42352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E9D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7456 46.349) scale(3.42901 3.42362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7005 43.3567) scale(2.72305 2.71869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6726 45.3537) scale(2.36834 2.36454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8354 44.2991) rotate(-90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5936 44.1919) rotate(90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FCE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7799 43.1365) rotate(180) scale(2.36834 2.36455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68F1D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8713 41.8028) scale(6.13608 6.12626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0D8B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2019 45.2373) scale(3.14481 3.13978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#005847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005B49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8589 42.0115) scale(3.06805 3.06313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C19A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9152 43.396) scale(4.13747 4.13084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA9C",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2862 45.8592) scale(2.49254 2.48855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1627 43.1402) scale(2.85969 2.85511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FABF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6136 43.2949) scale(4.27605 4.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00FCC9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6011 47.5087) scale(4.37667 4.36966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4829 41.9822) scale(2.63233 2.62812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9106 43.4952) scale(5.94785 5.93832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#74FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8995 42.0077) scale(3.86884 3.86264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFBDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9009 46.349) scale(3.42901 3.42352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E9D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9009 46.3488) scale(3.42901 3.42362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8558 43.3566) scale(2.72305 2.71869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8279 45.3535) scale(2.36834 2.36454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9907 44.2989) rotate(-90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7488 44.1918) rotate(90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FCE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9352 43.1364) rotate(180) scale(2.36834 2.36455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68F1D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9358 38.5617) scale(6.13608 6.12626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0D8B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2664 41.9962) scale(3.14481 3.13978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#005847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005B49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9234 38.7704) scale(3.06805 3.06313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C19A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9797 40.1549) scale(4.13747 4.13084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA9C",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3507 42.6181) scale(2.49254 2.48855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2271 39.8991) scale(2.85969 2.85511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FABF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6781 40.0538) scale(4.27605 4.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00FCC9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6655 44.2676) scale(4.37667 4.36966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5474 38.7411) scale(2.63233 2.62812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.975 40.2541) scale(5.94785 5.93832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#74FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9639 38.7666) scale(3.86884 3.86264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFBDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9653 43.1079) scale(3.42901 3.42352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E9D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9653 43.1077) scale(3.42901 3.42362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9202 40.1155) scale(2.72305 2.71869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8923 42.1125) scale(2.36834 2.36454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0551 41.0579) rotate(-90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.8133 40.9507) rotate(90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FCE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9997 39.8953) rotate(180) scale(2.36834 2.36455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68F1D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8059 44.381) scale(6.13608 6.12626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0D8B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1365 47.8155) scale(3.14481 3.13978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#005847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005B49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7935 44.5897) scale(3.06805 3.06313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C19A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8498 45.9743) scale(4.13747 4.13084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA9C",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2208 48.4374) scale(2.49254 2.48855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0972 45.7184) scale(2.85969 2.85511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FABF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5482 45.8732) scale(4.27605 4.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00FCC9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5356 50.0869) scale(4.37667 4.36966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4175 44.5604) scale(2.63233 2.62812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C39A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8451 46.0734) scale(5.94785 5.93832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#74FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.834 44.586) scale(3.86884 3.86264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFBDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8355 48.9272) scale(3.42901 3.42352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E9D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8355 48.9271) scale(3.42901 3.42362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7903 45.9349) scale(2.72305 2.71869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7624 47.9318) scale(2.36834 2.36454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9252 46.8772) rotate(-90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6834 46.77) rotate(90) scale(2.36454 2.36834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FCE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8698 45.7146) rotate(180) scale(2.36834 2.36455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68F1D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5725 34.6322) scale(15.117 15.117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#BCC1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#4B6064"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.572 10.1339) rotate(90) scale(30.3239 25.5435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000182901,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639659,
    stopColor: "#D8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#7E898A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5722 5.74548) scale(26.8333 26.8333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6251 28.8494) scale(13.3547 13.3547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6252 21.439) scale(24.1075 6.07664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#CECECE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0242 19.9355) rotate(-0.182297) scale(29.0261 6.28356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.6953 10.0013) scale(23.7446 23.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1909 27.5731) scale(12.2263 12.2263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_578_447482",
    x1: 46.5853,
    y1: 35.1224,
    x2: 46.5853,
    y2: 4.75056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#002020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3159 17.7622) scale(20.3884 20.3884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7723 19.1009) scale(15.2141 15.2141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D484E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.664 12.3752) scale(8.61408 8.61409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5855 31.0639) scale(16.2219 16.2219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_578_447482",
    x1: 46.5855,
    y1: 10.2755,
    x2: 46.5855,
    y2: 35.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    stopColor: "#B2B2B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3309 22.8808) scale(15.7894 15.7894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#D3D3D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7541 28.0821) scale(30.9521 30.952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4427 13.7131) scale(7.85261 7.85262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7165 14.6212) scale(11.8867 11.8867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778588"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2566 16.2452) scale(24.2646 24.2647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7135 13.817) scale(20.1089 20.1089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#F3F3F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6062 30.7325) scale(13.7837 13.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70898D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2BDBF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9321 28.201) scale(15.0822 15.0822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#F4F4F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5619 18.25) scale(15.5127 15.5127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8416 21.2766) scale(11.5332 11.5332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9908,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0177 17.1676) scale(23.8842 11.0497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0153 17.1687) scale(23.8842 11.0497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0026 17.1687) scale(23.8842 11.0497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#AFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#404545"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0906 16.7506) scale(27.8987 13.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8606 16.3936) scale(15.1245 17.0062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3295 16.3136) scale(10.3519 17.5069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8642 16.1832) scale(39.9371 16.8181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.c32906433328e7f7346c170eb55f6285.svg";
export { ForwardRef as ReactComponent };